<template>
<div class="relative">
    <v-dialog v-model="addSerialNumbersDialog" content-class="rounded-lg" max-width="550px" persistent>
        <v-card>
            <v-card-title>
                {{
                    canAddSerialNumber? $t('InvoiceBuyPage.add-serial-number') : $t('InvoiceBuyPage.serial-numbers')
                }}
            </v-card-title>
            <v-card-text>
                <bee-handy-smart-table
                    ref="serialNumberTable"
                    :headers="serialNumberHeaders"
                    :items="canAddSerialNumber ? tableInputs['serial-number'] || [] : serialNumbers"
                    v-model="serialNumber"
                    zebra
                    pagination-on-scroll
                    hide-inputs-details
                    fixed-header
                    hide-no-data-area
                    with-columns-divider
                    shown-rows-text=""
                    :show-add-row="canAddSerialNumber"
                    @keydown.enter="resetSerialNumberValue()"
                >
                    <template v-slot:item.actions="{index}">
                        <v-btn v-if="canAddSerialNumber" small icon :ripple="false"  class="ms-2 pa-0" color="red" @click="tableInputs['serial-number'].splice(index, 1)">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </template>
                </bee-handy-smart-table>
            </v-card-text>
            <v-card-actions class="pt-2">
                <v-btn
                    text
                    color="red"
                    @click="canAddSerialNumber = false;addSerialNumbersDialog = false"
                >
                    {{ $t('buttons.cancel') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog
        v-model="currentCurrencyDialog"
        width="400"
        persistent
    >
        <v-card class="rounded-lg">
            <v-card-title>
                {{ $t('change-currency.change-invoice-currency') }}
            </v-card-title>
            <v-card-text class="pb-1 pt-2">
                <div>
                    <v-row dense>
                        <v-col cols="12" lg="6">
                            <v-autocomplete
                                v-model="alternativeCurrencyId"
                                :items="configs.currencies"
                                item-value="id"
                                item-text="symbol"
                                dense
                                hide-details
                                outlined
                                :label="currencyNameUpdate"
                                class="rounded-lg"
                                @change="recommendCurrencyDefaultPriceUpdate(alternativeCurrencyId)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-text-field
                                v-model="alternativeCurrencyPrice"
                                dense
                                hide-details
                                outlined
                                :disabled="disableDefaultCurrencyPrice"
                                :label="$t('change-currency.currency-value')"
                                class="rounded-lg"
                                type="number"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    @click="update()"
                    color="transparent warning--text"
                    depressed
                >
                    {{ $t('change') }}
                </v-btn>
                <v-btn
                    @click="currentCurrencyDialog = false; resetCurrencyDialog()"
                    color="transparent red--text"
                    depressed
                >
                    {{ $t('cancel') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="serialNumberAlertDialog" content-class="rounded-lg" max-width="550">
        <v-card>
            <v-card-title>
                {{ $t('InvoiceBuyPage.choose-serial-number-alert') }}
            </v-card-title>
            <v-card-text class="pb-2 pt-2">
                {{ $t('headers.serial-number') }}
                :
                {{ serialNumberAlertText }}
                <br>
                {{ $t('InvoiceBuyPage.choose-serial-number-alert-content') }}
            </v-card-text>
            <v-card-actions class="pt-5 ">
                <v-btn
                    color="transparent"
                    class="green--text"
                    text
                    @click="serialNumberAlertDialog = false"
                >
                    {{ $t('buttons.ok') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- chang currency alert dialog -->
    <v-dialog 
        v-model="changeCurrencyAlertDialog"
        width="400"
        persistent
        
    >
        <v-card class="rounded-lg">
            <v-card-title>
                {{ $t('change-currency-alert.dialog-header') }}
            </v-card-title>
            <v-card-text class="pb-1">
                {{ $t('change-currency-alert.can-not-change-currency') }}
            </v-card-text>
            <v-card-actions>
                <v-btn
                    @click="changeCurrencyAlertDialog = false"
                    color="transparent grey--text"
                    depressed
                >
                    {{ $t('close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <div class="fixed white" style="width: 100%;" id="tool-bar">
    <v-row class="ma-0" style="width: 100%;" align="center" justify="start">
		<v-col cols="12" lg="auto" md="6" sm="12" xs="12">
			<slot name="breadcrumbs" :item="true"></slot>
		</v-col>
        <v-col
        	v-if="useInvoiceCategories"
        	md="2"
        	sm="3"
        	cols="12"
        >
            <v-autocomplete
                v-model="selectedInvoiceCategory"
                :label="$t('inputs.invoice-category')"
                :items="allInvoiceCategories"
                item-text="name"
                item-value="id"
                :item-disabled="item => item.id && !simplified_buy_invoices.filter(c => c.category_id === item.id).length"
                outlined 
                dense
                :disabled="loading"
                hide-details
                @change="$router.push({ name:'invoices-buy', query: {invoiceCategory: selectedInvoiceCategory}})"
            />
        </v-col>
        <v-col cols="auto" sm="auto" xs="auto" md="6" lg="auto" class="d-flex flex-row justify-start">
            <bee-bond-up-down
                v-model="invoice_no"
                :label="$t('InvoiceBuyPage.invoice-no')"
                :items="
                    !$route.query.invoiceCategory
                        ? simplified_buy_invoices.map(c => c.no)
                        : matchedCategoryInvoices.map(c => c.sub_no)
                "
                class="medium-placeholder"
                :disabled="loading || !simplified_buy_invoices.length"
                @keydown-enter-prevent="updateRouteId()"
                @programmatically-changed="updateRouteId()"
            ></bee-bond-up-down>
        </v-col>
        <v-col cols="12" sm="auto" xs="auto" md="auto" lg="auto" class="d-flex flex-column px-lg-0 justify-center">
			<bee-btn  
                v-if="createInvoicePermission"
				@click="addInvoiceDialog = true"
				:content="$t('InvoiceBuyPage.new')"
				color="addingColor"
				context="invoice"
                icon="fa-plus"
				:action-name="actions.CREATE"
                :disabled="file_is_locked || loading"
			></bee-btn>
		</v-col>
        <v-col cols="12" sm="auto" xs="auto" md="auto" lg="auto" class="d-flex flex-column justify-center">
			<bee-btn  
                v-if="deleteInvoicePermission"
				:content="$t('InvoiceBuyPage.delete')"
				color="deletingColor"
				context="invoice"
                icon="fa-trash"
				:action-name="actions.DELETE"
                :disabled="file_is_locked || loading"
                @click="dialogDeleteInvoice = true"
			></bee-btn>
		</v-col>
        <v-col cols="12" sm="auto" xs="auto" md="auto" lg="auto" class="d-flex flex-column justify-center px-1" v-if="!isWarehousePermission && useChangeCurrency">
            <v-tooltip bottom content-class="rounded-lg">
                <template v-slot:activator="{ on, attr }">
                    <v-btn
                        v-bind="attr"
                        v-on="on"
                        icon
                        :disabled="postingPermission || file_is_locked || loading"
                        @click="currentCurrencyDialog = true;"
                    >
                        <v-icon>
                            mdi-cash-multiple
                        </v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('change-currency.change-invoice-currency') }}</span>
            </v-tooltip>
        </v-col>
        <span class="grey--text text--darken-2" v-if="!isWarehousePermission && useChangeCurrency">
            {{configs.currencies.find(c => c.id === (invoice.alternative_currency_id ? invoice.alternative_currency_id : currentFinancialFile.default_currency_id)).symbol}}
        </span>
        <v-spacer></v-spacer>
        <v-col cols="auto" v-if="!isAccountantPermission && !isViewer">
             <v-tooltip right>
                <template v-slot:activator="{on, attrs}">
                    <div
                        v-on="on"
                        v-bind="attrs"
                    >
                        <v-btn
                            icon
                            :loading="materialsLoading"
                            :disabled="loading"
                            @click="fetchMaterials()"
                        >
                            <v-icon  color="primary" size="18">
                                fa-sync
                            </v-icon>
                        </v-btn>
                    </div>
                </template>
                {{$t('update-materials')}}
            </v-tooltip>
        </v-col>
        <v-col v-if="useInvoicesAuditLogs" cols="12" sm="auto" xs="auto" md="auto" lg="auto" class="d-flex flex-column justify-center px-0">
            <v-tooltip bottom content-class="rounded-lg">
                <template v-slot:activator="{ on, attr }">
                    <v-btn
                        v-bind="attr"
                        v-on="on"
                        small
                        depressed
                        color="transparent"
                        :disabled="loading || entryLoading"
                        @click="infoDialog = true"
                    >
                        <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('invoice-info') }}</span>
            </v-tooltip>
        </v-col>
        <!-- invoice posting progress circular -->
        <v-col cols="auto" class="d-flex justify-lg-end py-1">
            <router-link style="text-decoration: none;" :to="{name: 'invoices', query: { type: 1, status: postingPattern? 5 : 2 }}">
                <bee-progress-circular
                    :size="60"
                    :width="6"
                    :title="bond_posting_ratio_caption"
                    :value="bond_posting_ratio"
                    :tooltip="bond_posting_ratio_tooltip"
                ></bee-progress-circular>
            </router-link>
        </v-col>
        <v-col cols="auto">
            <v-menu offset-y>
                <template v-slot:activator="{ attr, on }">
                    <v-btn dark color="alert-color" v-on="on" v-bind="attr">
                        <v-icon class="me-1">mdi-export-variant</v-icon>
                        {{$t('exports.export')}}
                    </v-btn>
                </template>

                <v-list nav dense>
                    <v-list-item @click="getReport('pdf')">
                        <v-list-item-icon class="me-4">
                            <v-icon>mdi-printer</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{$t('exports.export-as-pdf')}}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="getReport('excel')">
                        <v-list-item-icon class="me-4">
                            <v-icon>mdi-microsoft-excel</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{$t('exports.export-as-excel')}}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-col>
    </v-row>
    <v-layout class="mx-3 mb-3 my-border rounded-lg d-flex flex-row wrap" align="center">
        <v-col cols="auto" lg="3" md="auto" sm="auto" xs="auto" class="pt-4 pb-0 pe-lg-0 d-flex flex-column">
            <bee-account-autocomplete
            :disabled="postingPermission || file_is_locked || loading"
            context="invoice"
            :action-name="actions.EDIT"
            :hide-details="false" 
            :rules="[rules.required]"
            :label="$t('InvoiceBuyPage.account')"
            color="primary"
            v-model="invoice.external_account_id"
            :items="configs.accounts.filter(c=>c.type == 2)"
            @change="update()"
            :with-balance="!isWarehousePermission"
            ></bee-account-autocomplete>
        </v-col>
        <v-col cols="auto" lg="auto" md="auto" sm="auto" xs="auto" class="pt-4 pb-0 pb-lg-0 d-flex flex-column">
        <bee-date-picker
            :disabled="postingPermission || file_is_locked || loading"
            context="invoice"
            :action-name="actions.EDIT"
            @blur="update()"
            :label="$t('InvoiceBuyPage.invoice-date')"
            v-model="invoice.date"
            :rules="[rules.date,
                v => moment(v).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD') || canAddFutureDate
            ]"
            :hide-details="false"
        ></bee-date-picker>
        </v-col>
        <v-col cols="12" sm="auto" xs="auto" md="auto" lg="2" class="d-flex flex-column pt-4 pb-lg-0 pb-0 ps-lg-0">
            <bee-autocomplete
                :disabled="postingPermission || file_is_locked || loading" 
                context="invoice"
                :action-name="actions.GET"
                :item-text="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_name' : 'name'"
                :item-value="userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_id' : 'id'"
                :label="$t('InvoiceBuyPage.warehouse')"
                :items="(userTypePermission === userType.warehouseKeeper && multipleWarehouses) ? warehousesForKeeper : warehouses"
                v-model="default_warehouse_id"
                :clearable="false"
                :hide-details="false"
                @change="changeWarehouse()"
            ></bee-autocomplete>
        </v-col>
        <v-col cols="auto" lg="auto" md="auto" sm="auto" xs="auto" class="pt-4 pb-0 pb-lg-0 px-md-0 d-flex justify-center flex-column">
            <bee-text-field
            	:disabled="postingPermission || file_is_locked || loading"
            	context="invoice"
            	:action-name="actions.EDIT"
            	@change="update()"
            	style="width: 100px !important"
            	:label="$t('InvoiceBuyPage.document')"
            	:hide-details="false"
            	:rules="!canCreateInvoiceWithoutDocNo ? [rules.required] : []"
            	v-model="invoice.doc_no"
            ></bee-text-field>
        </v-col>
        <v-col  v-if="useInvoiceCashType && !isWarehousePermission" class="pt-3 px-2">
            <v-radio-group
            	:disabled="postingPermission || file_is_locked || loading"
            	hide-details
            	class="py-0 my-0"
            	dense
                readonly
            	v-model="payment_type"
            >              
                <v-radio
                    @click="isCash?invoiceCashTypeDialog = true: ''"
                    on-icon="mdi-check-circle-outline"
                    small
                    class="mx-0 my-0"
                    :value="paymentType.debt"
                    :label="$t('InvoiceSalePage.debt')"
                ></v-radio>
                <v-radio
                	@click="!isCash?invoiceCashTypeDialog = true: ''"
                	on-icon="mdi-check-circle-outline"
                	small
                	class="mx-0 my-0"
                	:value="paymentType.cash"
                	:label="$t('InvoiceSalePage.cash')"
                ></v-radio>
            </v-radio-group>    
        </v-col>
        <v-spacer></v-spacer>
        <!-- <v-spacer v-if="false" class="hidden-sm-and-down"></v-spacer> -->
        <!-- <v-col v-if="!isWarehousePermission" cols="auto" lg="auto" md="auto" sm="auto" xs="auto" class="pb-lg- pt-lg-1 d-flex flex-column">
            <bee-outlined-header-info :head="$t('InvoiceBuyPage.net-invoice')" style="line-height: 1.5rem;" border-color="transparent" class="pa-lg-0" :column="on_lgAndUp">
                <template  v-slot:content="{}">
                    <bee-money-label :number="total_net" type="debit" :withColor="true" empty-state="_"></bee-money-label>
                </template>
            </bee-outlined-header-info>
        </v-col> -->

        <v-col
            v-if="!isMaterialsOnly && (isAdmin&& postingPattern !== postingPriorityType.both && postingButtonStatus)"
            cols="auto"
            sm="auto"
            xs="auto"
            md="auto"
            lg="auto"
            class="d-flex flex-lg-column justify-center py-lg-0 ps-lg-0"
        >
            <bee-btn context="invoice" :action-name="actions.EDIT" 
                :content="adminPostingTypeActions.primaryButton.text"
                :icon="adminPostingTypeActions.primaryButton.icon"
                :outer-class="on_lgAndUp ? ' text-wrap fs-6 mb-1' : 'fs-6 mx-2'" 
                :disabled="file_is_locked || secondaryPostingButtonLoading"
                :loading="primaryPostingButtonLoading" 
                :color="adminPostingTypeActions.primaryButton.color" 
                @click="
                        (
                            (
                                !tableInputs.warehouseId
                                || (
                                    tableInputs.warehouseId 
                                    && (!tableInputs.materialId || !tableInputs.quantity || (!useZeroInvoiceEntiresPrice ? !tableInputs.price : false)) 
                                    && !(!tableInputs.materialId && !tableInputs.quantity && (useZeroInvoiceEntiresPrice ? !tableInputs.price : true))
                                )
                            ) 
                            && !postingPermission 
                            ? confirmPostDialog = true 
                            : adminPostingTypeActions.primaryButton.action()
                        )
                    "
            >
            
            </bee-btn>
            <bee-btn context="invoice" :action-name="actions.EDIT" 
                :content="adminPostingTypeActions.secondaryButton.text"
                :icon="adminPostingTypeActions.secondaryButton.icon"
                :outer-class="on_lgAndUp ? ' text-wrap fs-6' : ' fs-6'" 
                :disabled="file_is_locked || primaryPostingButtonLoading"
                :loading="secondaryPostingButtonLoading" 
                :color="adminPostingTypeActions.secondaryButton.color" 
                @click="
                        (
                            (
                                !tableInputs.warehouseId
                                || (
                                    tableInputs.warehouseId 
                                    && (!tableInputs.materialId || !tableInputs.quantity || (!useZeroInvoiceEntiresPrice ? !tableInputs.price : false)) 
                                    && !(!tableInputs.materialId && !tableInputs.quantity && (useZeroInvoiceEntiresPrice ? !tableInputs.price : true))
                                )
                            ) 
                            && !postingPermission 
                            ? confirmPostDialog = true 
                            : adminPostingTypeActions.secondaryButton.action()
                        )
                    "
            >
            </bee-btn>
        </v-col>
        <v-col
            v-if="isMaterialsOnly || (!(isAdmin&& postingPattern !== postingPriorityType.both) && postingButtonStatus)"
        	cols="auto" 
        	sm="auto"
        	xs="auto"
        	md="auto"
        	lg="auto"
        	class="d-flex flex-column py-lg-0 ps-lg-0"
        >
            <bee-btn context="invoice" :action-name="actions.EDIT" 
                v-if="useUnPostingPermission
                ? (!postingPermission || (postingPermission && canUnPost))
                : true"
                :content="postingPermission? $t('edit'): $t('save')"
                :icon="postingPermission ? 'fa-envelope-open' : 'fa-envelope'"
                :outer-class="on_lgAndUp ? 'fill-height text-wrap' : ''" 
                :disabled="file_is_locked"
                :loading="updateInvoiceLoading" 
                :color="postingPermission ? 'deletingColor' : 'blueGray'" 
                @click="
                        (
                            (
                                !tableInputs.warehouseId
                                || (
                                    tableInputs.warehouseId 
                                    && (!tableInputs.materialId || !tableInputs.quantity || (!useZeroInvoiceEntiresPrice ? !tableInputs.price : false)) 
                                    && !(!tableInputs.materialId && !tableInputs.quantity && (useZeroInvoiceEntiresPrice ? !tableInputs.price : true))
                                )
                            ) 
                            && !postingPermission 
                            ? confirmPostDialog = true 
                            : (postingPermission ? unPosting() : posting())
                        )
                    "
            >
            </bee-btn>
        </v-col>
        
        <v-col cols="12" sm="12" xs="12" md="12" lg="" 
            class="d-flex flex-column align-center pa-lg-0"
            :class="[
                (invoice.posting_type === postingType.materialsJournal
                ||invoice.posting_type === postingType.bond) && 
                !isMaterialsOnly ? 'yellow darken-4' :  postingPermission ? 'postedColor' : 'unpostedColor',
                on_lgAndUp ? 'border-round-end' : 'border-round-bottom'
            ]"
        >
            <span class="d-flex justify-center text-center align-center fill-height text-wrap white--text font-weight-bold">
                {{ 
                !isMaterialsOnly 
                    ? invoice.posting_type === postingType.materialsJournal 
                        ? $t('invoices.warehouse-posted')
                        : invoice.posting_type === postingType.bond 
                            ? $t('invoices.posted-for-accounting')
                            :postingPermission 
                                ? $t('invoices.posted')
                                : $t('invoices.non-posted')
                    : invoice.posting_type === postingType.materialsJournal 
                        ? $t('invoices.posted')
                        : $t('invoices.non-posted')
                }}
            </span>
        </v-col>
    </v-layout>
    </div>

    <div class="ma-auto absolute pb-2" id="main" style="width: 100%; height: auto">
    <div class="px-3">
        <!-- <bee-smart-table
            v-if="false"
            v-model="tableInputs"
            mode="materials" 
            context="invoice" 
            :action-name="actions.CREATE" 
            ref="table" 
            :with-color="false" 
            :zebra="true" 
            empty-state="dashes" 
            :hide-footer="true"
            @cell-change="entries[$event.index][$event.header.value] = $event.value"
            :addable="addable && !file_is_locked" :editable="!postingPermission && !file_is_locked" :configs="[]" @reset-data="fetchInvoiceEntry($event)" 
            :headers="headers"
            :items="entries || []"
            :show-menu-actions="true"
            @row-edited="updateEntry($event)"
            @row-added="addInvoiceEntry($event)" 
            @delete-item="deleteInvoiceEntry($event)"
            :right-click-menu-items="actionsList"
            :messagesSelectRowValidation="messagesSelectRowValidation"
            @nblur="handlBlurBoundTable"
            >
        </bee-smart-table> -->
        
        <bee-handy-smart-table
            v-model="tableInputs"
            :headers="tableHeaders"
            :items="entries || []"
            :loading="loading || entryLoading"
            ref="table"
            zebra
            dense
            fixed-header
            :height="$vuetify.breakpoint.height - 340"
            :items-per-page="30"
            hot-inputs="lazy"
            :disable-input-fields="loading || entryLoading || updateInvoiceLoading"
            pagination-on-scroll
            hide-inputs-details
            hide-no-data-area
            with-columns-divider
            stay-in-input-fields
            :show-add-row="showAddRowPermission && Boolean($route.params.id) && !isViewer"
            :editable-rows="!postingPermission && Boolean($route.params.id) && !isViewer"
            :data-table-props="{ disableSort: true }"
            :validation-messages.sync="validationMessages"
            :context-menu-items="contextMenuItems"
            :disable-context-menu="postingPermission || loading || entryLoading || updateInvoiceLoading || isViewer"
            :scroll-to-row-expression="(item) => item.id === entryId || item.id === entries[entries.length - 1].id"
            @context-menu-edit="({ item }) => entryId = item.id"
            @context-menu-delete="({ item }) => deleteInvoiceEntry(item)"
            @edit-cancelled="entryId = null"
            @keydown.enter="entryHandler"
            @reached-last-input="!saveInvoiceWithLastEntry ? entryHandler() : null" 
        >
            <template v-slot:input.warehouseId="{ attr, on }">
                <v-autocomplete
                    v-on="on"
                    v-bind="attr"
                    class="text-subtitle-2"
                    :items="
                        userTypePermission === userType.warehouseKeeper && multipleWarehouses
                            ? warehousesForKeeper
                            : warehouses
                    "
                    :item-value="
                        userTypePermission === userType.warehouseKeeper && multipleWarehouses
                            ? 'warehouse_id'
                            : 'id'
                    "
                    :item-text="
                        userTypePermission === userType.warehouseKeeper && multipleWarehouses
                            ? 'warehouse_name'
                            : 'name'
                    "
                />     
            </template>
            <template v-slot:input.delivery_status_id="{ attr, on }">
                <v-autocomplete
                    v-on="on"
                    v-bind="attr"
                    class="text-subtitle-2"
                    :items="deliveryStatus.filter(c => c.invoice_type === 1)"
                    item-text="name"
                    item-value="id"
                    dense
                    hide-details
                >
                </v-autocomplete>
            </template>
        
            <template v-slot:input.materialId="{ attr }">
                <!-- <bee-material-autocomplete
                    v-on="on"
                    v-bind="attr"
                    :inside-table="true"
                    :with-balance="true"
                    :items="materials.filter(c => c.warehouse_id === tableInputs.warehouseId && c.type === 2)"
                    style="padding-bottom: 2px !important;"
                    @change="recommendMaterialData()"
                /> -->
                <v-autocomplete
                    v-model="tableInputs.materialId"
                    v-bind="attr"
                    :items="materials.filter(c => c.warehouse_id === tableInputs.warehouseId && c.type === 2)"
                    :item-text="c => `${c.no} - ${c.name}`"
                    item-value="id"
                    class="text-subtitle-2"
                    dense
                    hide-details
                    @change="recommendMaterialData()"
                >
                    <template v-slot:item="data">
                        <v-list-item
                            v-on="data.on"
                            v-bind="data.attrs"
                        >
                            <div class="d-flex flex-column py-1">
                                <span>
                                    {{ data.item.no + '-'+ data.item.name }}
                                </span>
                            </div>
                            <v-spacer></v-spacer>
                            <bee-material-amount-label :with-color="true" :value="data.item.balance" :show-zeros-values="true"></bee-material-amount-label>

                        </v-list-item>
                    </template>
                </v-autocomplete>
            </template>
            <template v-slot:item.serial-number="{item}">
                <div class="d-flex align-center justify-center">
                    <v-btn v-if="item.serial_number?.length" text :ripple="false" class="" @click.stop="serialNumbers = item.serial_number ;addSerialNumbersDialog = true">
                        <span class=" greyDarken2--text me-1">
                            {{ 
                                item.serial_number?.length || null
                            }}
                        </span>
                        <v-icon small>
                            mdi-script-text-outline
                        </v-icon>
                    </v-btn>
                    <span v-else>-</span>
                </div>
            </template>
            <template v-slot:input.serial-number="{attr}">
                <v-text-field
                    v-bind="attr"
                    v-model="serialNumber.value"
                    class="text-subtitle-2"
                    dense
                    hide-details
                    @change="checkMaterialSerialNumber(tableInputs.materialId, serialNumber.value)"     
                    @keydown.enter="resetSerialNumberValue"              
                >
                    <template v-slot:append>
                        <div class="d-flex align-center">
                            <span class=" greyDarken2--text">
                                {{ 
                                tableInputs['serial-number']?.length || null
                                }}
                            </span>
                            <v-btn class="" small icon  @click="canAddSerialNumber = true;addSerialNumbersDialog = true">
                                <v-icon small>
                                    mdi-script-text-outline
                                </v-icon>
                            </v-btn>
                        </div>
                        <!-- <v-menu :close-on-content-click="false" max-height="40vh" offset-y>
                            <template v-slot:activator="{ on, attrs }">

                            </template>
                            <v-list  dense>
                                <div v-if="tableInputs['serial-number']?.length">
                                    <v-list-item
                                        v-for="(item, index) in tableInputs['serial-number']"
                                        :key="index"
                                        class="px-2"
                                    >
                                        <v-list-item-content  class="py-0 text-subtitle-2">
                                            <div class="d-flex justify-space-between align-center">
                                                {{ item }}
                                                <v-btn small icon  class="ms-2 pa-0" color="red" @click="tableInputs['serial-number'].splice(index, 1)">
                                                    <v-icon small>mdi-close</v-icon>
                                                </v-btn>
                                            </div>
                                        </v-list-item-content>
                                    </v-list-item>
                                </div>
                                <div v-else class="px-2 py-1 text-subtitle-2">
                                    قم بإدخال الرقم ثم اضغط enter لإضافته
                                </div>
                            </v-list>
                        </v-menu> -->
                    </template>
                </v-text-field>
            </template>
            <!-- 
            :items="
                warehouse_materials.length
                    ? warehouse_materials
                    : userTypePermission === userType.warehouseKeeper && multipleWarehouses
                        ? materials.filter(c => c.warehouse_id === tableInputs.warehouseId && c.type === 2)
                        : materials.filter(c => c.type === 2)
            "
            -->

            <template v-slot:no-input.hint>
                <v-menu bottom v-if="validationMessages.length > 0">
                    <template v-slot:activator="{ on, attr }">
                        <v-icon
                            v-on="on"
                            v-bind="attr"
                            color="danger-color"
                            size="18"
                        >mdi-information</v-icon>
                    </template>

                    <v-list>
                        <v-list-item
                            v-for="(message, i) in inputsValidationMessages"
                            :key="i"
                            dense
                            class="px-2"
                        >
                            <v-list-item-icon class="me-0 mb-0">
                                <v-icon color="danger-color" x-small>mdi-circle-half</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title class="danger-color--text">
                                {{message}}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
            <template v-slot:pagination-on-scroll.page-text="{shownItemsLength, totalItems}">
                <v-row dense>
                    <v-col 
                        cols="auto" 
                        class="px-1 text-subtitle-2" 
                        :style="{ marginRight: ($vuetify.breakpoint.width - $vuetify.breakpoint.width / 2 - 75) + 'px' }"
                    >
                        <span>{{ $t('total-quantities') }} {{ totalQuantities?.toLocaleString('en') }} </span>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col 
                        cols="auto" 
                        class="px-1"
                        :style="{
                            marginLeft: ($vuetify.breakpoint.width / 4 - 115) + 'px',
                        }"
                    >
                        <span>
                            {{ $t('total-counts') }} {{ totalCounts?.toLocaleString('en') }} 
                        </span>
                    </v-col>
                    <v-col cols="auto" class="me-5">
                        <span>
                            {{shownItemsLength}} / {{totalItems}}
                        </span>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.hint="{ item, index }">
                <div class="text-center">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attr }">
                            <v-btn
                                small
                                icon
                                v-bind="attr"
                                v-on="on"
                                width="32"
                            >
                                <v-icon>
                                    mdi-dots-vertical
                                </v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item @click="$refs.table.activeEditForRow(index); entryId = item.id">
                                <v-list-item-content class="pa-0">
                                    {{ $t('buttons.edit') }}
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="deleteEntryPermission" @click="deleteInvoiceEntry(item)">
                                <v-list-item-content class="pa-0">
                                    {{ $t('buttons.delete') }}
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </template>
        </bee-handy-smart-table>

        <!-- alertMessageDialog -->
        <v-dialog v-model="alertMessageDialog" width="400">
            <v-card>
                <v-card-title>
                    {{ $t('InvoiceBuyPage.alert-message') }}
                </v-card-title>

                <v-card-text>
                    {{ $t('InvoiceBuyPage.confirm-message') }}
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer />
                    <v-btn @click="alertMessageDialog = false; !isEdit ? addRowForEntriesDialog(InvoicesTransactionType.payment) : editRowForEntriesDialog(InvoicesTransactionType.payment)" color="greenDarken1" text>
                        {{ $t('buttons.ok') }}
                    </v-btn>

                    <v-btn 
                        color="redDarken1" 
                        @click="
                            alertMessageDialog =  false;
                            $refs.tableReceipt.resetInputs({
                                date: moment().format('YYYY-MM-DD')
                            })
                        " 
                        text
                    >
                        {{ $t('buttons.cancel') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <!-- dialog payment -->
        <v-dialog v-model="dialogPaymentOrExpenses" width="700" >
            <v-card>
                <v-card-title class="d-flex justify-space-between align-center pb-4">
                    <p class="ma-0">
                        {{ !isExpenses ? $t('InvoiceBuyPage.payments') : $t('InvoiceBuyPage.expenses') }}
                    </p>
                </v-card-title>

                <v-card-text>
                    <bee-handy-smart-table
                        ref="tablePayment"
                        v-model="inputsPaymentsOrExpenses"
                        :items="entriesDialog"
                        :headers="headersPaymentsOrExpenses"
                        :items-per-page="-1"
                        :data-table-props="{ disableSort: true }"
                        dense
                        zebra
                        hide-default-footer
                        :disable-input-fields="submitLoading"
                        :show-add-row="!submitLoading && !postingPermission&& !isViewer && this.invoice.posting_type !== postingType.bond"
                        hide-inputs-details
                        :editable-rows="!submitLoading && !postingPermission && !isViewer && this.invoice.posting_type !== postingType.bond"
                        :loading="submitLoading"
                        @keypress.enter="confirmTotalPaymentsForTotalNet()"
                    >
                        <template v-slot:input.date="{ on, attr }">
                            <bee-date-input 
                                label=" "
                                fit-inputs
                                dense
                                input-format-order="DD-MM-YYYY"
                                v-on="on"
                                v-bind="attr"
                            />
                            <!-- <v-text-field
                                v-on="on"
                                v-bind="attr"
                                class="mb-3"
                                :hide-details="true"
                                type="date"
                            ></v-text-field> -->
                        </template>

                        <template v-slot:input.account_id="{ on, attr }">
                            <bee-account-autocomplete
                                context="invoice"
                                :action-name="actions.CREATE"
                                :hide-details="false"             
                                color="primary" 
                                :items="configs.accounts.filter(c=>c.type == 2)"
                                :with-balance="true"
                                v-on="on"
                                v-bind="attr"
                            ></bee-account-autocomplete>
                        </template>

                        <!-- no-input action -->
                        <template v-slot:no-input.actions>
                            <div class="d-flex justify-center">
                                <tooltip :text="$t('buttons.add')" top>
                                    <v-btn
                                        icon
                                        small
                                        color="greenDarken1"
                                        @click="
                                            confirmTotalPaymentsForTotalNet()
                                        "
                                        :disabled="submitLoading"
                                    >
                                        <v-icon>
                                            mdi-check-circle-outline
                                        </v-icon>
                                    </v-btn>
                                </tooltip>
                            </div>
                        </template>

                        <template v-slot:item.actions="{ index, item }">
                            <div class="d-flex justify-center">
                                <v-tooltip v-if="useExportPaymentBond && !isExpenses && postingPermission" bottom>
                                    <template v-slot:activator="{on, attrs}">
                                        <div v-on="on" v-bind="attrs">
                                            <v-btn
                                                icon
                                                class="primary--text"
                                                @click="exportPaymentBond(item)"
                                            >
                                                <v-icon class="mx-1">
                                                    mdi-invoice-import-outline
                                                </v-icon>
                                            </v-btn>

                                        </div>
                                    </template>
                                    <span >
                                        {{ $t('InvoiceBuyPage.export-payment-bond') }}
                                    </span>
                                </v-tooltip>
                                <div  v-if="!postingPermission&& !isViewer && this.invoice.posting_type !== postingType.bond" class="d-flex justify-center">
                                    <v-btn
                                        icon
                                        small
                                        color="warning-color"
                                        @click="() => {
                                            transactionId = item.id
                                            $refs.tablePayment.activeEditForRow(index);
                                            editRowIndex = index;
                                            isEdit = true;
                                            $nextTick(() => {
                                                $refs.tablePayment.resetInputsFocus()
                                            })
                                        }"
                                    >
                                        <v-icon>
                                            mdi-pencil
                                        </v-icon>
                                    </v-btn> 

                                    <v-btn
                                        icon
                                        small
                                        color="deletingColor"
                                        @click="transactionId = item.id; deleteRowForPayments()"
                                    >
                                        <v-icon>
                                            mdi-delete
                                        </v-icon>
                                    </v-btn>  
                                </div>
                            </div>
                            
                        </template>
                    </bee-handy-smart-table>
                </v-card-text>

                <v-card-actions class="pt-0">
                    <v-spacer />
                    <v-btn
                    	@click="[dialogPaymentOrExpenses = false,$refs.tablePayment.resetEdit()]"
                    	color="greenDarken1"
                    	text
                    >
                        {{ $t('buttons.ok') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-form v-model="valid" ref="form">
        <v-dialog transition="dialog-top-transition" v-model="addInvoiceDialog" max-width="500">
            <v-card>
            <v-card-title class="headline">{{$t('InvoiceBuyPage.add-invoice')}}</v-card-title>
            <v-card-text class="pb-2">
            <v-row class="ma-0">
                <v-col cols="auto" lg="12" class="pa-0">
                    <bee-date-picker
                    	context="invoice"
                    	:action-name="actions.CREATE"
                    	:label="$t('InvoiceBuyPage.invoice-date')"
                    	v-model="invoice_template.date"
                    	:rules="[
                            rules.date,
                            v => moment(v).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD') || canAddFutureDate
                        ]"
                    ></bee-date-picker>
                </v-col>
                <v-col cols="auto" lg="6" class="pt-0" v-if="useInvoiceCategories">
                    <v-autocomplete
                        v-model="invoice_template.category_id"
                        :label="$t('inputs.invoice-category')"
                        :items="invoiceCategories"
                        item-text="name"
                        item-value="id"
                        outlined 
                        dense
                        hide-details
                        @change="suggestCategoryData()"
                        clearable
                    ></v-autocomplete>
                </v-col>
                <v-col cols="auto" lg="6" class="pt-0" v-if="useConfigInvoicesAccount">
                    <v-autocomplete
                    	v-model="invoice_template.account_trade_config_id"
                    	:label="$t('inputs.purchasing-account')"
                    	:items="tradeConfigAccounts"
                    	item-text="name"
                    	item-value="id"
                    	outlined
                    	dense
                    	hide-details
                    	clearable
                    ></v-autocomplete>
                </v-col>
                <v-col cols="auto" lg="9" class="py-0 d-flex flex-column">
                    <bee-account-autocomplete
                    	context="invoice"
                    	:action-name="actions.CREATE"
                    	:hide-details="!isWarehousePermission ? true : false"
                    	:rules="[rules.required]"
                    	:label="$t('InvoiceBuyPage.account')"
                    	color="primary"
                    	v-model="invoice_template.external_account_id"
                    	:items="configs.accounts.filter(c=>c.type == 2)"
                    	:with-balance="!isWarehousePermission"
                    ></bee-account-autocomplete>
                </v-col>
                <v-col cols="auto" lg="auto" class="py-0 ps-0">
                    <bee-text-field
                    	context="invoice"
                    	:action-name="actions.EDIT"
                    	style="width: 100px !important"
                    	:label="$t('InvoiceBuyPage.document')"
                    	:hide-details="!isWarehousePermission ? true : false"
                    	:rules="!canCreateInvoiceWithoutDocNo ? [rules.required] : []"
                    	v-model="invoice_template.doc_no"
                    ></bee-text-field>
                </v-col>
                <v-col cols="12" lg="6" v-if="!isWarehousePermission && useChangeCurrency">
                    <v-autocomplete
                        v-model="invoice_template.alternative_currency_id"
                        :items="configs.currencies"
                        :label="currencyNameCreate"
                        item-value="id"
                        item-text="symbol"
                        dense
                        hide-details
                        outlined
                        class="rounded-lg"
                        @change="recommendCurrencyPriceCreate(invoice_template.alternative_currency_id)"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" lg="6" v-if="!isWarehousePermission && useChangeCurrency">
                    <v-text-field
                        v-model="invoice_template.currency_price"
                        dense
                        hide-details
                        outlined
                        :disabled="disableDefaultCurrencyPriceCreate"
                        :label="$t('change-currency.currency-value')"
                        class="rounded-lg"
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="auto" lg="12" class=" my-1">
                    <bee-text-field
                    	context="invoice"
                    	:action-name="actions.EDIT"
                    	:label="$t('InvoiceBuyPage.notes')"
                    	v-model="invoice_template.notes"
                    	:hide-details="true"
                    ></bee-text-field>
                </v-col>
                <v-col class="pb-0 pt-3">
                    <div v-if="useInvoiceCashType && !isWarehousePermission" class="d-flex align-center my-2">
                        <p class=" mb-1">{{$t('InvoiceSalePage.payment-type')}}:</p>
                        <v-radio-group  hide-details class="my-0 mx-2 py-0 pa-0" dense row v-model="invoice_template.payment_type">
                            <v-radio  class="mx-3" :value="paymentType.debt" :label="$t('InvoiceSalePage.debt')" />
                            <v-radio  class="mx-0" :value="paymentType.cash" :label="$t('InvoiceSalePage.cash')" />
                        </v-radio-group>
                    </div>
                </v-col>
            </v-row>
            </v-card-text>
            <v-card-actions class="ms-3">
                <v-btn color="greenDarken1" text @click="create()" :loading="loading" :disabled="!valid || file_is_locked">{{$t('InvoiceBuyPage.create')}}</v-btn>
                <v-btn color="redDarken1" text @click="reSet()" >{{$t('InvoiceBuyPage.cancel')}}</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
            </v-card>
        </v-dialog>
        </v-form>
        <bee-dialog
            @handler="confirmDeleteInvoiceEntry()"
            @close="dialogDeleteEntry = false"
            v-model="dialogDeleteEntry"
            :title="$t('InvoiceBuyPage.delete-entry')"
            :message="$t('InvoiceBuyPage.are-you-sure-you-want-to-delete-the-entry')"
        ></bee-dialog>
        <bee-dialog
            @handler="deleteInvoice()"
            @close="dialogDeleteInvoice = false"
            v-model="dialogDeleteInvoice"
            :title="$t('InvoiceBuyPage.delete-invoice')"
            :message="$t('InvoiceBuyPage.are-you-sure-you-want-to-delete-the-invoice-that-will-delete-the-associated-bond')"
        ></bee-dialog>
    </div>
    <v-bottom-navigation id="footer" height="auto" app horizontal class="px-3">
    <v-row class="fill-height ma-0" style="width: 100%" align="center">            
        <v-col
            v-if="useBuyInvoicePayments && !isWarehousePermission"
            cols="auto"
            lg="auto"
            md="auto"
            sm="auto"
            xs="auto"
            class="align-center justify-start d-flex pe-lg-0 ps-lg-1"
        >
            <!-- payments sum --> 
            {{$t('InvoiceBuyPage.total-payments') + ': ' }}
            <span 
                class="ms-2 me-4 font-weight-bold"
                :class="{
                    'green--text': total_net === totalPayments,
                    'red--text': total_net !== totalPayments
                }"
            > 
                {{ (totalPayments ? (totalPayments).toLocaleString() : 0 ) }} 
            </span>
            <v-btn
                :color="(!postingPermission && !isViewer && this.invoice.posting_type !== postingType.bond ? 'success' : 'info-color') + ' white--text'"
                class="px-0 rounded-xl" 
                min-width="0"
                width="28"
                height="28"
                @click="dialogPaymentOrExpenses = true" 
                :disabled="loading && !postingPermission && Boolean($route.params.id)"
            >
                <v-icon color="white" size="22" class="mx-0"> mdi-{{!postingPermission && !isViewer && this.invoice.posting_type !== postingType.bond ? 'plus' : 'eye'}} </v-icon>  
            </v-btn>    
        </v-col>

        <!-- Expenses -->
        <v-col
            v-if="isMaterialsOnly || useBuyInvoiceExpenses && !isWarehousePermission"
            cols="auto"
            lg="auto"
            md="auto"
            sm="auto"
            xs="auto"
            class="align-center justify-start d-flex pe-lg-0"
        >
            <!-- payments sum --> 
            {{$t('InvoiceBuyPage.total-expenses') + ': ' }}
            <span 
                class="ms-2 me-4 font-weight-bold"
            > 
                {{ (totalExpenses ? (totalExpenses).toLocaleString() : 0 ) }} 
            </span>
            <v-btn
                :color="(!postingPermission && !isViewer && this.invoice.posting_type !== postingType.bond ? 'success' : 'info-color') + ' white--text'"
                class="px-0 rounded-xl" 
                min-width="0"
                width="28"
                height="28"
                @click="isExpenses = true; dialogPaymentOrExpenses = true" 
                :disabled="loading"
            >
                <v-icon color="white" size="22" class="mx-0"> mdi-{{!postingPermission && !isViewer && this.invoice.posting_type !== postingType.bond ? 'plus' : 'eye'}} </v-icon>  
            </v-btn>    
        </v-col>

        <!-- <v-spacer/> -->
        <v-col cols="auto" lg="2" md="auto" sm="auto" xs="auto" class="align-center justify-start d-flex pe-lg-0">
            <bee-text-field
                :disabled="postingPermission || file_is_locked || loading"
                context="invoice"
                :action-name="actions.EDIT"
                @change="update()"
                :label="$t('InvoiceBuyPage.notes')"
                v-model="invoice.notes"
                :hide-details="true" 
            />
        </v-col>
        <v-col cols="auto" lg="2" v-if="useConfigInvoicesAccount">
            <v-autocomplete
            	v-model="invoice.account_trade_config_id"
            	:label="$t('inputs.purchasing-account')"
            	:items="tradeConfigAccounts"
            	item-text="name"
            	item-value="id"
            	:disabled="postingPermission || file_is_locked || loading"
            	outlined
            	dense
            	hide-details
            	clearable
            	@change="update()"
            ></v-autocomplete>
        </v-col>
        <v-col cols="auto" lg="2" v-if="useInvoiceCategories && invoice.category_id">
            <v-autocomplete
                v-model="invoice.category_id"
                :label="$t('inputs.invoice-category')"
                :items="invoiceCategories"
                item-text="name"
                item-value="id"
                outlined
                dense
                hide-details
                disabled
            ></v-autocomplete>
        </v-col>
        <v-spacer/>
        <v-col
            v-if="!isWarehousePermission"
            cols="auto"
            :lg="useInvoiceCategories ? '1' : 'auto'"
            md="auto"
            sm="auto"
            xs="auto"
            class="align-center justify-start d-flex"
        >
            <bee-money-field
            	v-model="alternativeDiscountTotal"
            	:label="$t('InvoiceBuyPage.discount')"
            	:disabled="postingPermission || file_is_locked || !total || loading"
            	context="invoice"
            	:action-name="actions.EDIT"
            	:hide-details="true"
            	:rules="[rules.money]"
            	@blur="update()"
            ></bee-money-field>
        </v-col>

        <v-col v-if="!isWarehousePermission" cols="auto" lg="auto" md="auto" sm="auto" xs="auto" class="align-start flex-column d-flex py-1">
        <bee-outlined-header-info :head="$t('InvoiceBuyPage.total')" border-color="transparent" class="pa-lg-0">
            <template  v-slot:content="{}">
                <bee-money-label :number="total" type="debit" :withColor="true" empty-state="_"></bee-money-label>
            </template>
        </bee-outlined-header-info>

        <bee-outlined-header-info v-if="!isWarehousePermission" :head="$t('InvoiceBuyPage.net-invoice')" border-color="transparent" class="pa-lg-0">
            <template  v-slot:content="{}">
                <bee-money-label :number="total_net" type="debit" :withColor="true" empty-state="_"></bee-money-label>
            </template>
        </bee-outlined-header-info>
        </v-col>
    </v-row>
    </v-bottom-navigation>
    </div>
    <!-- the code of the confirm dialog goes here -->
    <v-dialog
        v-model="confirmPostDialog"
        max-width="500"
    >
        <v-card class="rounded-lg">
            <v-card-title>
                {{ $t('dialog-content.confirm-dialog-title') }}
            </v-card-title>
            <v-card-text class="pb-1">
                {{ $t('dialog-content.confirm-dialog-content') }}
            </v-card-text>
            <v-card-actions>
                <v-btn
                    @click="posting()"
                    color="green--text transparent"
                    depressed
                >{{ $t('dialog-content.confirm-dialog-actions.confirm') }}</v-btn>
                <v-btn
                    @click="confirmPostDialog = false"
                    color="red--text transparent"
                    depressed
                >{{ $t('dialog-content.confirm-dialog-actions.cancel') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- the code of the info dialog goes here -->
    <v-dialog
        v-model="infoDialog"
        max-width="550"
        content-class="rounded-xl"
        persistent
    >
        <v-card
            class="rounded-xl"
        >
            <v-card-title class="rounded-xl">{{ $t('invoice-info') }}</v-card-title>
            <v-card-text class="pb-1">
                <bee-handy-table
                    :headers="infoHeaders"
                    :items="invoice.audit_log_simplified_responses || []"
                    pagination-on-scroll
                    shown-rows-text=""
                    fixed-header
                    dense
                    elevation="1"
                    zebra
                >
                    <template v-slot:item.type="{ item }">
                        <span  
                            :class="
                                item.type === actionType.create ? 'green--text'
                                : item.type === actionType.post ? 'blue--text' 
                                : item.type === actionType.unPost ? 'warning--text' 
                                : null"
                        >
                        {{ actionTypes.find(c => c.type === item.type)?.name }}
                        <!-- {{
                            actionTypes
                                .slice()
                                .sort((a, b) => new Date(a.date) - new Date(b.date))
                                .find(c => c.type === item.type)?.name
                        }} -->
                        </span>
                    </template>
                    <template v-slot:item.date="{ item }">
                        <div dir="auto" class="d-flex justify-end">
                            {{ moment(item.date_formatted).locale('en').format('h:mm:ss A ,YYYY-MM-DD') }}
                        </div>
                    </template>
                </bee-handy-table>
            </v-card-text>
            <v-card-actions class="rounded-xl">
                <v-btn 
                    color="transparent grey--text"
                    smal
                    depressed
                    @click="infoDialog = false"
                >
                    <span>{{ $t('close') }}</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog
        v-model="invoiceCashTypeDialog"
        width="600">
        <v-card>
            <v-card-title>
                {{ $t('InvoiceSalePage.payment-type-alert') }}
            </v-card-title>
            <v-card-text>
                {{ isCash? $t('InvoiceSalePage.change-from-debt-to-cash'):$t('InvoiceSalePage.change-from-cash-to-debt') }}
            </v-card-text>
            <v-card-actions>
                <v-btn color="greenDarken1" text @click="change_payment_type = isCash? paymentType.debt : paymentType.cash; update(); invoiceCashTypeDialog = false">
                    موافق
                </v-btn>
                <v-btn color="redDarken1" text  @click="invoiceCashTypeDialog = false">
                    الغاء
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>
<script>
import rules from "../../../validation";
import actions from "../../../permissions/actions-names.js"
import { mapState, mapGetters } from "vuex";
import  store  from "../../../store/index.js";
import { invoiceEntryDetectedValidation } from "./helper/validation-detected-invoice-entry";
import { refactorRecord } from "./helper/operations-calculated-properties.js"
import EventBus from '../../../event-bus'
import {finalType, userType, invoiceType, bondType, InvoicesTransactionType, materialDeliveryStatus, type, postingType, actionTypes, actionType, postingPriorityType, userPermission, paymentType, paymentReceiptBondType } from '@/helpers/enums';
import { multipleWarehouses, isMangeUnitAndRegionAndPatchAndLot, separationOfInvoices, useBuyInvoicePayments,useBuyInvoiceExpenses, useMaterialStatusDeliver, useConfigInvoicesAccount, useUnPostingPermission, useInvoiceCategories, useZeroInvoiceEntiresPrice, canCreateInvoiceWithoutDocNo, saveInvoiceWithLastEntry, useChangeCurrency, useInvoiceCashType, useInvoicesAuditLogs } from '@/configs/global'
import moment from 'moment'
import ls from "@/settings/localStorageExtension";

// FIXME use user warehouses
// const multipleWarehouses = false;

export default {
data: () => 
    ({
        dialogDeleteInvoice: false,
        loading: false,
        valid: false,
        addInvoiceDialog: false,
        default_warehouse_id: null,
        selected_warehouse_id: null,
        invoice_no: null,
        ...rules,
        messagesSelectRowValidation: [],
        actions,
        invoice_template:{
            external_account_id: null,
            date: moment().format('YYYY-MM-DD'),
            doc_no: null,
            notes: null,
            account_trade_config_id: null,
            category_id: null,
            payment_type: paymentType.debt,
            alternative_currency_id: null,
            currency_price: null
        },
        linkedInvoiceRules: {
            price: true, quantity: true, count: true, material_id: true
        },
        entry: null,
        dialogDeleteEntry: false,

        updateInvoiceLoading: false,
        userType,
        userPermission,
        invoiceType,
        multipleWarehouses,
        isMangeUnitAndRegionAndPatchAndLot,
        separationOfInvoices,
        useBuyInvoicePayments,
        dialogPaymentOrExpenses: false,
        inputsPaymentsOrExpenses: {
            date: moment().format('YYYY-MM-DD')
        },
        // payments: [],
        editRowIndex: null,
        isEdit: false,
        useInvoicesAuditLogs,
        // inputs
        entryLoading: false,
        entryId: null,
        validationMessages: [],
        tableInputs: {},
        InvoicesTransactionType,
        submitLoading: false,
        transactionId: null,
        totalPayments: null,
        alertMessageDialog: false,

        useBuyInvoiceExpenses,
        totalExpenses: null,
        isExpenses: false,
        entriesDialog: [],
        materialDeliveryStatus,
        useMaterialStatusDeliver,
        useConfigInvoicesAccount,
        useUnPostingPermission, 
        useInvoiceCategories,
        canCreateInvoiceWithoutDocNo,
        useZeroInvoiceEntiresPrice,
        saveInvoiceWithLastEntry,
        useInvoiceCashType,
        selectedInvoiceCategory: null,
        postingPriorityType,
        infoDialog: false,
        actionTypes,
        actionType,
        paymentType,
        confirmPostDialog: false,
        currency: null,
        currentCurrencyDialog: false,
        changeCurrencyAlertDialog: false,
        alternativeCurrency: false,
        useChangeCurrency,

        alternativeCurrencyId: null,
        alternativeCurrencyPrice: null,

        alternativeDiscountTotal: {},
        payment_type: '',
        invoiceCashTypeDialog: false,
        postingType,
        primaryPostingButtonLoading: false,
        secondaryPostingButtonLoading: false,
        change_payment_type: null,
        materialSerialNumbers: [],
        serialNumberAlertDialog: false,
        serialNumberAlertText: null,
        addSerialNumber: false,
        serialNumber: {},
        addSerialNumbersDialog: false,
        canAddSerialNumber: false,
        serialNumbers: [],
        invoice: {},
        materialsLoading: false
    }),

    watch: {
        '$route' (newVal, oldVal) {
            this.selectedInvoiceCategory = newVal.query.invoiceCategory || null;
            if(newVal.params.id) {
                // this.loading = true;
                this.fetchInvoice(Number(newVal.params.id))
                // this.$store.dispatch('invoices/fetch', {
                //     invoiceId: Number(newVal.params.id),
                //     invoiceType: invoiceType.buy
                // }).then((data) => {
                //     this.invoice_no = !this.$route.query.invoiceCategory ? data.no : data.sub_no;
                //     this.changeWarehouse();
                //     this.payment_type = data.payment_type;
                //     this.change_payment_type = null;
                //     this.loading = false;
                //     this.alternativeDiscountTotal = data.alternative_currency_id ? data.alternative_discount_total : data.discount_total
                //     this.alternativeCurrency = Boolean(this.invoice.alternative_currency_id)
                //     if (this.invoice.alternative_currency_id === null) {
                //         this.alternativeCurrencyId = this.currentFinancialFile.default_currency_id;
                //         this.alternativeCurrencyPrice = 1
                //     } else {
                //         this.alternativeCurrencyId = this.invoice.alternative_currency_id
                //         this.recommendCurrencyPriceUpdate(this.alternativeCurrencyId)
                //     }
                //     this.$nextTick(() => {
                //         if(!this.postingPermission){
                //             this.$refs.table.scrollToRow();
                //         }
                //     })
                //     this.totalPayments =
                //         data.transactions.length
                //             ? data.transactions
                //                 .filter(c => c.type === InvoicesTransactionType.payment)
                //                 .map(c => 
                //                     this.invoice.alternative_currency_id 
                //                         ? c.alternative_amount?.amount 
                //                         : c.amount?.amount
                //                     )
                //                 .reduce((a, b) => a + b, 0)
                //             : null

                //     this.totalExpenses =
                //         data.transactions.length
                //             ? data.transactions
                //                 .filter(c => c.type === InvoicesTransactionType.expensesBuy)
                //                 .map(c => 
                //                     this.invoice.alternative_currency_id 
                //                         ? c.alternative_amount?.amount 
                //                         : c.amount?.amount
                //                     )
                //                 .reduce((a, b) => a + b, 0)
                //             : null
                // })
            } else if(oldVal.params.id  && this.simplified_buy_invoices.find(v => v.id === +oldVal.params.id)) {
                if(newVal.query.invoiceCategory === this.selectedInvoiceCategory || !newVal.query.invoiceCategory) {
                    const latestMatchedInvoiceId = this.matchedCategoryInvoices[this.matchedCategoryInvoices.length - 1]?.id
                    this.$router.push({name: 'invoices-buy', params: { id: latestMatchedInvoiceId }, query: newVal.query});
                }
            }
                // console.log(this.selectedInvoiceCategory);
            // else {
            //     this.updateRouteId();
            // }
        },
        dialogPaymentOrExpenses (val) {
            if(val) {
                this.getAllPaymentsOrExpenses(this.isExpenses ? InvoicesTransactionType.expensesBuy : InvoicesTransactionType.payment)
            } else {
                this.entriesDialog = []
                this.transactionId = null
                this.isExpenses = false
                this.$refs.tablePayment.resetInputs()
            }
           
        },
        addInvoiceDialog() {
            let categoryId;

            if (this.$route.query.invoiceCategory) {
                categoryId = this.$route.query.invoiceCategory;
            } else {
                categoryId = this.defaultInvoiceCategories
                    .find(c => c.invoice_type === invoiceType.buy)?.category_id;
            }

            if (useInvoiceCategories && categoryId) {
                const invoiceCategory = this.getInvoiceCategoryById(categoryId);
                this.invoice_template.category_id = categoryId;
                this.invoice_template.account_trade_config_id = invoiceCategory.purchases_account_id;
                this.invoice_template.external_account_id = invoiceCategory.customer_account_id
            }
        },
        // selectedInvoiceCategory(val) {
        //     if (this.matchedCategoryInvoices.length && useInvoiceCategories) {
        //         const latestMatchedInvoiceId =
        //             this.matchedCategoryInvoices[this.matchedCategoryInvoices.length - 1].id
        //         let query = val ? { invoiceCategory: val } : {};
        //         if(JSON.stringify(this.$route.query) !== JSON.stringify(query) || latestMatchedInvoiceId !== +this.$route.params.id) {
        //             this.$router.replace({
        //                 name: this.$route.name,
        //                 params: { id: latestMatchedInvoiceId },
        //                 query
        //             })
        //         }
        //     }
        // },
    },

computed: {
    ...mapState("configs" , ["configs"]),
    ...mapState("invoices" , ["buy_invoice"]),
    ...mapState("invoices" , ["simplified_buy_invoices"]),
    ...mapState("warehouses" , ["warehouses"]),
    ...mapState("materials" , ["materials"]),
    ...mapState({
        userTypePermission: state => state.permissions.user_type,
        currentFinancialFile: state => state.financialFiles.current_financial_file,
        numOfNotPostedInvoices: state => state.configs.configs.num_of_not_posted_invoices.filter(c => c.invoice_type === invoiceType.buy),
        numOfTotalBuyInvoices: state => state.configs.configs.num_of_total_invoices.filter(c => c.invoice_type === invoiceType.buy),
        // warehousesForKeeper: state => state.warehouses.warehousesForKeeper,
        warehousesForKeeper: state => state.permissions.warehousesForKeeper,
        
        defaultFinancialFileAccounts: state => state.configs.default_financial_file_accounts,
        canUnPost: state => state.permissions.selfPermissions.canUnPost,
        invoiceCategories: state =>
            state.invoiceCategories.invoiceCategories
                .filter(c => c.category_invoice_types.map(c => c.invoice_type).includes(invoiceType.buy)),
        defaultInvoiceCategories: state => state.invoiceCategories.defaultInvoiceCategories,
        deliveryStatus: state => state.deliveryStatus.deliveryStatus,
        postingPriority: state=> state.settings.postingType,
        users: state => state.users.users,
        isAdmin: state => state.auth.self.is_admin,
    }),
    ...mapGetters({
        getAccountById: 'configs/getAccountById',
        getWarehouseById: 'warehouses/getById',
        getMaterialById: 'materials/getMaterialById',
        getInvoiceCategoryById: 'invoiceCategories/getInvoiceCategoryById',
        isViewer: 'permissions/isViewer',
        getUserById: 'users/getUserById',
        getSettingByKey: 'settings/getSettingByKey'
    }),
    isMaterialsOnly() {
        return this.invoiceCategories.find(v => v.id === this.invoice.category_id)?.is_materials_only;
    },
    warehouse_materials(){
        return this.materials.filter(c=> this.selected_warehouse_id ? c.warehouse_id == this.selected_warehouse_id : true)
                    .filter(c=>c.type == 2)
    },
    file_is_locked(){ return this.configs?.financial_file?.is_locked },
    on_mdAndUp(){ return (this.$vuetify.breakpoint.mdAndUp) },
    addable(){
		return this.postingPermission || !this.invoice_no ? false : true
	},

    total(){ 
        return this.invoice?.invoice_entries?.map(c => 
            this.alternativeCurrency
                ? c.alternative_calculated_total_amount?.amount
                    ? c.alternative_calculated_total_amount.amount 
                    : 0 
                : c.calculated_total_amount?.amount 
                    ? c.calculated_total_amount.amount 
                    : 0
        ).reduce((previousValue, currentValue) => previousValue + currentValue, 0) 
    },
    on_lgAndUp(){ return(this.$vuetify.breakpoint.lgAndUp) },

    infoHeaders() {
        const headers = [
            {
                text: this.$t('invoice-headers.action'),
                value: 'type',
                name: 'type',
                sortable: false
            },
            {
                text: this.$t('invoice-headers.date-formatted'),
                value: 'date_formatted',
                name: 'date',
                sortable: false
            },
            {
                text: this.$t('invoice-headers.user'),
                value: 'user_id',
                setValueExpr: value => this.getUserById(value)?.user_name,
                name: 'userName',
                sortable: false
            }
        ]
        return headers
    },

    totalQuantities() {
        return this.entries?.reduce((sum, item) => {
            return sum + item.quantity
        }, 0)
    },

    totalCounts() {
        return this.entries?.reduce((sum, item) => {
            return sum + item?.count
        }, 0)
    },
    isCash() {
        return this.payment_type === paymentType.cash
    },
    tableHeaders(){
        let headers = [
            {
                text: this.$t('InvoiceBuyPage.headers.no'),
                name: 'no',
                value: 'no',
                width: 30,
                noInput: true,
            },
            {
                text: this.$t('InvoiceBuyPage.headers.warehouse'),
                name: 'warehouseId',
                value: 'warehouse_id',
                width: '13vw',
                setValueExpr: val => {
                    const warehouse = this.getWarehouseById(val);
                    return warehouse ? warehouse.name : null;
                },
                disableInput: this.tableDisabledInputs('warehouse')
            },
            {
                text: this.$t('InvoiceBuyPage.headers.material'),
                name: 'materialId',
                value: 'material_id',
                width:'15vw',
                editable: true,
                inputRules: [rules.rules.required],
                setValueExpr: val => {
                    const material = this.getMaterialById(val);
                    return material ? material.name : null;
                },
                disableInput: this.tableDisabledInputs('material')
            },
            this.showMaterialSpecificationsColumn
                ?{
                    text: this.$t('headers.material-specifications'),
                    name: 'material-specifications',
                    value: 'material_specifications',
                    width: '10vw',
                    type: 'string',
                    disableInput: true
                } 
                : null,
            this.useMaterialSerialNumber 
                ? {
                    text: this.$t('headers.serial-number'),
                    name: 'serial-number',
                    value: 'serial_number',
                    width: 130,
                    disableInput: this.tableDisabledInputs('serial-number'),
                    inputRules: [() => this.tableInputs['serial-number']?.length === this.tableInputs.quantity ||  !this.getMaterialById(this.tableInputs.materialId)?.is_required_serial_num],
                    type: 'array'
                }
                :null,
            {
                text: this.$t('InvoiceBuyPage.headers.quantity'),
                name: 'quantity',
                value: 'quantity',
                type: 'number-format',
                width: 60,
                inputRules: [rules.rules.required],
                disableInput: this.tableDisabledInputs('quantity')
            },
            ...((!this.isWarehousePermission && !this.isMaterialsOnly)
                ? [ 
                    {
                        text: this.$t('InvoiceBuyPage.headers.price'),
                        name: 'price',
                        value: this.alternativeCurrency ? 'alternative_price.amount' : 'price',
                        type: 'number-format',
                        width: 100,
                        inputRules: !useZeroInvoiceEntiresPrice ? [rules.rules.required] : [],
                        disableInput: this.tableDisabledInputs('price')
                    },
                    {
                        text: this.$t('InvoiceBuyPage.headers.total-amount'),
                        name: 'calculatedTotalAmount',
                        value: this.alternativeCurrency ? 'alternative_calculated_total_amount.amount' : 'calculated_total_amount',
                        type: 'number-format',
                        width: 100,
                        setInputExpr: (inputs, activeInput) => {
                            if (activeInput === 'calculatedTotalAmount') {
                                if (inputs.quantity) {
                                    this.tableInputs.price = inputs.calculatedTotalAmount / inputs.quantity;
                                    this.$nextTick(() => {
                                        this.tableInputs.calculatedTotalAmount = inputs.quantity * inputs.price;
                                    })
                                } else {
                                    return inputs.calculatedTotalAmount;
                                }
                            } else if (['quantity', 'price'].includes(activeInput)) {
                                return inputs.quantity * inputs.price;
                            } else {
                                return inputs.calculatedTotalAmount
                            }
                        },
                        disableInput: this.tableDisabledInputs('calculatedTotalAmount')
                    }
                ]
                : []
            ),
            {
                text: this.$t('InvoiceBuyPage.headers.count'),
                name: 'count',
                value: 'count',
                type: 'number-format',
                width: 50,
                disableInput: this.tableDisabledInputs('count')
            },
            useMaterialStatusDeliver 
                ? {
                    text: this.$t('InvoiceBuyPage.headers.delivery-status'),
                    value: 'delivery_status_id',
                    name: 'delivery_status_id',
                    width: 120,
                    noNotAvailableText: true,
                    setValueExpr: val => this.deliveryStatus.find(c => c.id === val)?.name,
                    disableInput: this.tableDisabledInputs('deliveryStatus')
                } 
                : null,
            ...(isMangeUnitAndRegionAndPatchAndLot 
                    ? [
                        {
                            text: 'رقم الباتش',
                            name: 'patchNumber',
                            value: 'patchNumber',
                            editable: true,
                            width: '10%',
                            disableInput: this.tableDisabledInputs('patch')
                        },
                        {
                            text: 'رقم اللوت',
                            name: 'lotNumber',
                            value: 'lotNumber',
                            editable: true,
                            width: '10%',
                            disableInput: this.tableDisabledInputs('lot')
                        },
                        {
                            text: 'تاريخ الانتهاء',
                            name: 'endDate',
                            value: 'endDate',
                            type: 'date',
                            editable: true,
                            width: '13%',
                            disableInput:this.tableDisabledInputs('endDate')
                        }
                    ] 
                    : []
            ),
            {
                text: this.$t('InvoiceBuyPage.headers.notes'),
                name: 'notes',
                value: 'notes', 
                disableInput: this.tableDisabledInputs('notes')
            },
            !this.postingPermission 
                ? {
                    text: '',
                    name: 'hint',
                    value: 'hint',
                    noInput: true,
                    noNotAvailableText: true,
                    divider: false,
                    width:   30
                }
                : null
        ]
        headers = headers.filter(v => Boolean(v));
        for (let i = 0; i < headers.length; i++) {
            if (i === headers.length - 1 && !this.postingPermission) {
                headers[i].class = headers[i].class ? headers[i].class + ' px-0' : 'px-0';
                headers[i].cellClass = headers[i].cellClass ? headers[i].cellClass + ' px-0' : 'px-0';
            } else {
                headers[i].class = headers[i].class ? headers[i].class + ' px-1 text-subtitle-2 ' : 'px-1 text-subtitle-2';
                headers[i].cellClass = headers[i].cellClass ? headers[i].cellClass + ' px-1 text-subtitle-2' : 'px-1 text-subtitle-2';
            }
            headers[i].align='center';
        }
        // if(useMaterialStatusDeliver) {
        //     headers.splice(5, 0, {
        //         text: this.$t('InvoiceBuyPage.headers.delivery-status'),
        //         value: 'delivery_status_id',
        //         name: 'delivery_status_id',
        //         width: '140',
        //         noNotAvailableText: true,
        //         setValueExpr: val => this.deliveryStatus.find(c => c.id === val)?.name,
        //         disableInput: this.tableDisabledInputs('deliveryStatus')
        //     })
        // }
        // if(isMangeUnitAndRegionAndPatchAndLot) {
        //     headers.splice(5,0, 
        //     {
        //         text: 'رقم الباتش',
        //         name: 'patchNumber',
        //         value: 'patchNumber',
        //         editable: true,
        //         width: '10%',
        //         disableInput: this.tableDisabledInputs('patch')
        //     },
        //     {
        //         text: 'رقم اللوت',
        //         name: 'lotNumber',
        //         value: 'lotNumber',
        //         editable: true,
        //         width: '10%',
        //         disableInput: this.tableDisabledInputs('lot')
        //     },
        //     {
        //         text: 'تاريخ الانتهاء',
        //         name: 'endDate',
        //         value: 'endDate',
        //         type: 'date',
        //         editable: true,
        //         width: '13%',
        //         disableInput:this.tableDisabledInputs('endDate')
        //     })
        // }
        // if(!this.isWarehousePermission) { 
        //     headers.splice(5, 0, {
        //         text: this.$t('InvoiceBuyPage.headers.price'),
        //         name: 'price',
        //         value: this.alternativeCurrency ? 'alternative_price.amount' : 'price',
        //         type: 'number-format',
        //         width: '6%',
        //         inputRules: !useZeroInvoiceEntiresPrice ? [rules.rules.required] : [],
        //         disableInput: this.tableDisabledInputs('price')
        //     },
        //     {
        //         text: this.$t('InvoiceBuyPage.headers.total-amount'),
        //         name: 'calculatedTotalAmount',
        //         value: this.alternativeCurrency ? 'alternative_calculated_total_amount.amount' : 'calculated_total_amount',
        //         type: 'number-format',
        //         width: '10%',
        //         setInputExpr: (inputs, activeInput) => {
        //             if (activeInput === 'calculatedTotalAmount') {
        //                 if (inputs.quantity) {
        //                     this.tableInputs.price = inputs.calculatedTotalAmount / inputs.quantity;
        //                     this.$nextTick(() => {
        //                         this.tableInputs.calculatedTotalAmount = inputs.quantity * inputs.price;
        //                     })
        //                 } else {
        //                     return inputs.calculatedTotalAmount;
        //                 }
        //             } else if (['quantity', 'price'].includes(activeInput)) {
        //                 return inputs.quantity * inputs.price;
        //             } else {
        //                 return inputs.calculatedTotalAmount
        //             }
        //         },
        //         disableInput: this.tableDisabledInputs('total')
        //     })
        // }
        // if(!this.postingPermission) {
        //     headers.push({
        //         text: '',
        //         name: 'hint',
        //         value: 'hint',
        //         noInput: true,
        //         noNotAvailableText: true,
        //         class: 'px-0',
        //         cellClass: 'px-0',
        //         divider: false,
        //         width: !this.isWarehousePermission ? '2%' : '1%',
        //     })
        // }
        return headers;
    },
    headers(){
        const headers = [
            {
                text: this.$t('InvoiceBuyPage.headers.no'),
                value: 'no',
                type: 'string', 
                width: !this.isWarehousePermission ? '3%' : '19.5%',
                editable: false,
                settings: { context: 'invoice', actionName: actions.GET }
            },
            {
                text: this.$t('InvoiceBuyPage.headers.warehouse'),
                value: 'warehouse_id',
                type: 'autocomplete',
                width: !this.isWarehousePermission ? '17%' : '19.5%',
                editable: true,
                required: true,
                settings: { itemText: 'name', items: this.warehouses , clearable: true,
                itemValue: this.userTypePermission === userType.warehouseKeeper && multipleWarehouses ? 'warehouse_id' : 'id', contex: 'warehouses', actionName: actions.GET }
            },
            {
                text: this.$t('InvoiceBuyPage.headers.material'),
                value: 'material_id',
                type: 'materials-autocomplete',
                width: '20%',
                editable: true, rules:[this.linkedInvoiceRules.material_id],
                settings: { itemText: undefined, items: this.materials.filter(c => c.type === 2), subItems: this.warehouse_materials }
            },
            {
                text: this.$t('InvoiceBuyPage.headers.quantity'),
                value: 'quantity',
                type: 'numeric',
                width: !this.isWarehousePermission ? '15%' : '19.5%',
                editable: true, rules:[this.linkedInvoiceRules.quantity],
                settings: { context: 'invoice', actionName: actions.GET }
            },
            {
                text: this.$t('InvoiceBuyPage.headers.count'),
                value: 'count',
                type: 'numeric',
                width: !this.isWarehousePermission ? '15%' : '19.5%',
                editable: true,
                settings: { context: 'invoice', actionName: actions.GET }
            },
            {
                text: this.$t('InvoiceBuyPage.headers.notes'),
                value: 'notes',
                type: 'string',
                width: !this.isWarehousePermission ? '15%' : '19.5%',
                editable: true,
                required: true,
                settings: { context: 'invoice', actionName: actions.GET } 
            },
            {
                text: '',
                value: 'hint',
                type: 'hint',
                width: !this.isWarehousePermission ? '2%' : '1%',
                editable: false
            },
        ]
        if(isMangeUnitAndRegionAndPatchAndLot) {
            headers.splice(5,0, 
            {
                text: 'رقم الباتش',
                name: 'patchNumber',
                value: 'patchNumber',
                type: 'string',
                editable: true,
                settings: { context: 'invoice', actionName: actions.GET },
                width: '10%'
            },
            {
                text: 'رقم اللوت',
                name: 'lotNumber',
                value: 'lotNumber',
                type: 'string',
                editable: true,
                settings: { context: 'invoice', actionName: actions.GET },
                width: '10%'
            },
            {
                text: 'تاريخ الانتهاء',
                name: 'endDate',
                value: 'endDate',
                type: 'date',
                editable: true,
                settings: { context: 'invoice', actionName: actions.GET },
                width: '13%'
            })
        }
        if(!this.isWarehousePermission) { 
            headers.splice(4, 0, {
                text: this.$t('InvoiceBuyPage.headers.price'),
                value: 'price',
                type: 'numeric',
                width: '15%',
                editable: true, rules:[this.rules.money && this.linkedInvoiceRules.price],
                settings: { context: 'invoice', actionName: actions.GET }
            },
            {
                text: this.$t('InvoiceBuyPage.headers.total-amount'),
                value: 'calculated_total_amount',
                type: 'numeric',
                width: '15%',
                editable: true,
                settings: { context: 'invoice', actionName: actions.GET }
            },)
            // headers.splice(7,0 , 
            // // {
            //     //     text: this.$t('InvoiceBuyPage.headers.price'),
            //     //     value: 'price',
            //     //     type: 'numeric',  
            //     //     width: '15%',
            //     //     editable: true, rules:[this.rules.money && this.linkedInvoiceRules.price],
            //     //     settings: { context: 'invoice', actionName: actions.GET }
            //     // },
            //     // {
            //     //     text: this.$t('InvoiceBuyPage.headers.total-amount'),
            //     //     value: 'calculated_total_amount',
            //     //     type: 'numeric',
            //     //     width: '15%',
            //     //     editable: true,
            //     //     settings: { context: 'invoice', actionName: actions.GET }
            //     // },
            //     )

        }
        return headers
    },
    serialNumberHeaders() {
        return [
            {
                name: 'id',
                setValueExpr: (v, i) => i+1 ,
                value: 'id',
                width: 30,
                disableInput: true,
                sortable: false
            },
            {
                name: 'value',
                value: 'value',
                type: 'string',
                text: this.$t('InvoiceBuyPage.serial-number'),
                sortable: false
            },
            {
                name: 'actions',
                text: '',
                value: '',
                noInput: true,
                width: 30,
                sortable: false,
                divider: false
            }
        ]
    },
    // youHavePermission() {
        
    //     return this.userTypePermission !== userType.warehouseKeeper && this.userTypePermission !== userType.warehouseManger
    // },
    postingPattern() {
        return +this.getSettingByKey('Posting Pattern')?.setting_value
    },
    adminPostingTypeActions() {
        if(this.postingPattern === postingPriorityType.warehouseWorkersFirst) {
            return {
                primaryButton: {
                    color: !this.invoice.posting_type? 'blueGray':'deletingColor',
                    icon: !this.invoice.posting_type? 'fa-envelope' : 'fa-envelope-open',
                    text: !this.invoice.posting_type
                        ? this.$t(`save-for-warehouse`)
                        : this.invoice.posting_type === postingType.materialsJournal
                            ? this.$t(`edit-for-warehouse`)
                            : this.$t(`edit-for-accounting`),
                    action: !this.invoice.posting_type
                        ? () => {
                            this.primaryPostingButtonLoading = true;
                            this.posting(postingType.materialsJournal);
                        }
                        : this.invoice.posting_type === postingType.materialsJournal
                            ? () => {
                                this.primaryPostingButtonLoading = true;
                                this.unPosting(postingType.materialsJournal) 
                            }
                            : () => {
                                this.primaryPostingButtonLoading = true;
                                this.unPosting(postingType.bond)
                            }
                },
                secondaryButton: {
                    color: this.invoice.posting_type === postingType.both? 'deletingColor':'blueGray',
                    icon: this.invoice.posting_type === postingType.both? 'fa-envelope-open' : 'fa-envelope',
                    text: !this.invoice.posting_type
                    ? this.$t(`save-for-all`)
                    : this.invoice.posting_type === postingType.materialsJournal
                        ? this.$t(`save-for-accounting`)
                        : this.$t(`edit-for-all`),
                    action: !this.invoice.posting_type
                    ? () => {
                        this.secondaryPostingButtonLoading = true;
                        this.posting(postingType.both)}
                    : this.invoice.posting_type === postingType.materialsJournal
                        ? () => {
                            this.secondaryPostingButtonLoading = true;
                            this.posting(postingType.bond) 
                        }
                        : () => {
                            this.secondaryPostingButtonLoading = true;
                            this.unPosting(postingType.both)
                        }
                }
            }
        }
        if(this.postingPattern === postingPriorityType.accountantFirst) {
            return {
                primaryButton: {
                    color: !this.invoice.posting_type? 'blueGray':'deletingColor',
                    icon: !this.invoice.posting_type? 'fa-envelope' : 'fa-envelope-open',
                    text: !this.invoice.posting_type
                        ? this.$t(`save-for-accounting`)
                        : this.invoice.posting_type === postingType.bond
                            ? this.$t(`edit-for-accounting`)
                            : this.$t(`edit-for-warehouse`) ,
                    action: !this.invoice.posting_type
                        ? () => {
                            this.primaryPostingButtonLoading = true;
                             this.posting(postingType.bond)
                        } 
                        : this.invoice.posting_type === postingType.bond
                            ? () => {
                                this.primaryPostingButtonLoading = true;
                                this.unPosting(postingType.bond)
                            }
                            : () => {
                                this.primaryPostingButtonLoading = true;
                                this.unPosting(postingType.materialsJournal) 
                            }
                },
                secondaryButton: {
                    color: this.invoice.posting_type === postingType.both? 'deletingColor':'blueGray',
                    icon: this.invoice.posting_type === postingType.both? 'fa-envelope-open' : 'fa-envelope',
                    text: !this.invoice.posting_type
                    ? this.$t(`save-for-all`)
                    : this.invoice.posting_type === postingType.bond
                        ?  this.$t(`save-for-warehouse`)
                        : this.$t(`edit-for-all`),
                    action: !this.invoice.posting_type
                    ?() => {
                            this.secondaryPostingButtonLoading = true;
                            this.posting(postingType.both)
                        } 
                    : this.invoice.posting_type === postingType.bond
                        ? () => {
                            this.secondaryPostingButtonLoading = true;
                            this.posting(postingType.materialsJournal)
                        }
                        : () => {
                            this.secondaryPostingButtonLoading = true;this.unPosting(postingType.both)
                        }
                }
            }
        }
        return true;
    },
    postingPermission(){
        if(this.postingPattern === postingPriorityType.warehouseWorkersFirst) {
            if (this.isAccountantPermission) {
                    return this.invoice.posting_type === postingType.both
            }
            if (this.isWarehousePermission) {
                    return this.invoice.posting_type === postingType.materialsJournal ||
                    this.invoice.posting_type === postingType.both
            }
        }
        if(this.postingPattern === postingPriorityType.accountantFirst){
            if(this.isAccountantPermission) {
                return this.invoice.posting_type === postingType.bond 
                || this.invoice.posting_type === postingType.both
            }
            if(this.isWarehousePermission) {
                return this.invoice.posting_type === postingType.both
            }
        }
        return this.invoice.is_posted;
    },
    userPostingTypeValue() {
        if(this.postingPattern === postingPriorityType.both)
            return 0;
        if (this.isAccountantPermission)
            return postingType.bond;
        if (this.isWarehousePermission)
            return postingType.materialsJournal;
        if(this.isAdmin)
            return postingType.both;
        return 0;
    },
    isWarehousePermission() {
        return this.isMaterialsOnly || ((this.userTypePermission === userType.warehouseKeeper && separationOfInvoices) || (this.userTypePermission === userType.warehouseManger && separationOfInvoices))
    },
    isAccountantPermission() {
        return (this.userTypePermission === userPermission.accountant && separationOfInvoices) || 
            (this.userTypePermission === userPermission.advanceAccountant && separationOfInvoices)
    },
    postingButtonStatus() {
        if(this.postingPattern === postingPriorityType.warehouseWorkersFirst) {
            if (this.isAccountantPermission) {
                return this.invoice.posting_type !== postingType.unknown && this.invoice.posting_type;
            }
            if (this.isWarehousePermission) {
                return this.invoice.posting_type !== postingType.both;
            }
        }
        if(this.postingPattern === postingPriorityType.accountantFirst) {
            if(this.isWarehousePermission) {
                return this.invoice.posting_type;
            }
            if(this.isAccountantPermission) {
                return this.invoice.posting_type !== postingType.both
            }
        }
        return !this.isWarehousePermission;
    },
    deleteInvoicePermission() {
        if(!this.isAdmin && this.postingPermission) {
            return false;
        }
        if(this.postingPattern === postingPriorityType.both) {
            return !this.isWarehousePermission;
        }
        if (this.postingPattern === postingPriorityType.warehouseWorkersFirst) {
            return !this.isAccountantPermission;
        }
        return this.isMaterialsOnly || !this.isWarehousePermission;
    },
    createInvoicePermission() {
        if(this.postingPattern === postingPriorityType.warehouseWorkersFirst)
            return !this.isAccountantPermission
        if(this.postingPattern === postingPriorityType.accountantFirst)
            return this.isMaterialsOnly || !this.isWarehousePermission;
        return true
    },
    showAddRowPermission() {
        if(this.postingPattern === postingPriorityType.warehouseWorkersFirst) {
            if(this.isAccountantPermission && !this.invoice.posting_type){
                return false;
            }
            return !this.invoice.posting_type; 
        }
        if(this.postingPattern === postingPriorityType.accountantFirst) {
            if(this.isWarehousePermission && !this.invoice?.posting_type)
                return false;
            return !this.invoice.posting_type;
        }
        return !this.postingPermission;
    },
    deleteEntryPermission() {
        if(this.postingPattern === postingPriorityType.warehouseWorkersFirst) {
            if(this.isAccountantPermission)
                return false;
            return !this.invoice.posting_type;
        }
        if(this.postingPattern === postingPriorityType.accountantFirst) {
            if (this.isWarehousePermission)
                return false;
            return !this.invoice.posting_type
        }
        return !this.invoice.is_posted;
    },
    entries(){
        return this.invoice.invoice_entries?.map(c=> {
            const material = this.materials.find(x => x.id == c.material_id);
            return ({ no: c.no, 
                warehouse_id: material?.warehouse_id, 
                id: c.id,
                material_id: c.material_id,
                material_specifications: material?.specifications,
                quantity: c.quantity.quantity,
                count: c.count,
                price: c.price.amount,
                calculated_total_amount: c.calculated_total_amount.amount,
                notes: c.notes,
                type: c.type,
                delivery_status_id: c.delivery_status_id,
                alternative_calculated_total_amount: c.alternative_calculated_total_amount,
                alternative_price: c.alternative_price,
                serial_number:  c.serial_number?.map(v => ({value: v})) 
            })
        })
    },
    total_net() { 
        return this.alternativeDiscountTotal?.amount 
            ? this.total - this.alternativeDiscountTotal.amount : this.total 
    },
    actionsList(){
        return [
            {
                name: 'edit',
                disabled: this.postingPermission,
                action_name: actions.EDIT,
                text: this.$t('InvoiceBuyPage.context-menu.edit')
            }, 
            {
                name: 'delete-item',
                disabled: this.postingPermission,
                action_name: actions.DELETE,
                text: this.$t('InvoiceBuyPage.context-menu.delete')
            }
        ]
    },

    bond_posting_ratio() {
        return this.numOfTotalBuyInvoices.length
            ? 100 -
            ((this.numOfNotPostedInvoices.length ? this.numOfNotPostedInvoices[0].count : 0) * 100) /
                this.numOfTotalBuyInvoices[0].count
        : 100   
    },

    bond_posting_ratio_tooltip() {
        return this.numOfNotPostedInvoices.length
            ? `${this.numOfNotPostedInvoices[0].count} ${this.$t('unposted-invoices')}`
            : this.$t('unposted-invoices');
    },

    bond_posting_ratio_caption() {
        return `${this.numOfNotPostedInvoices.length ? this.numOfNotPostedInvoices[0].count : 0}/${this.numOfTotalBuyInvoices.length ? this.numOfTotalBuyInvoices[0].count : 0}`;
    },
    headersPaymentsOrExpenses() {
        const headers = [
            {
                text: this.$t('headers.date'),
                value: 'date',
                name: 'date',
                width: 110,
                inputRules: [this.rules.required]
            },
            {
                text: this.$t('headers.amount'),
                name: 'amount',
                value: this.alternativeCurrency ? 'alternative_amount.amount' : 'amount.amount',
                type: 'number-format',
                inputRules: [this.rules.required]
            },
            {
                text: this.$t('headers.note'),
                name: 'notes',
                value: 'notes',
                width: '40%'
            },
            {
                text: '',
                name: 'actions',
                value: 'actions',
                noNotAvailableText: true,
                noInput: true
            }
        ]
        if(this.isExpenses) {
            headers.unshift({
                text: this.$t('headers.account'),
                name: 'account_id',
                value: 'account_id',
                setValueExpr: val => this.configs.accounts.find(c => c.id === val)?.name
            })

        }
        return headers
    },

    inputsValidationMessages() {
        const messages = [];
        const inputs = this.tableInputs;
        if (!inputs.materialId) {
            messages.push(this.$t('table-messages.material-required'))
        }
        if (!inputs.quantity) {
            messages.push(this.$t('table-messages.quantity-required'))
        }
        if (!inputs.price) {
            messages.push(this.$t('table-messages.price-required'))
        }
        return messages
    },

    contextMenuItems() {
        const items = [
            {
                event: 'edit',
                title: this.$t('InvoiceBuyPage.context-menu.edit'),
            }
        ]
        if( this.deleteEntryPermission ) 
            items.push({
                event: 'delete',
                title: this.$t('InvoiceBuyPage.context-menu.delete'),
            })
        return items
    },

    tradeConfigAccounts() {
        return [
            { 
                ...(
                    this.getAccountById(this.defaultFinancialFileAccounts.purchases_account_id) || {}
                ),
                id: null
            },
            ...this.configs.accounts,
        ].filter(c =>
            ( this.accountFinalTypeRestrict ? c.final_type === finalType.trade : true) &&
            c.type === type.sub &&
            c.id !== this.defaultFinancialFileAccounts.purchases_account_id
        )
    },

    allInvoiceCategories() {
        return [
            { id: null, name: this.$t('InvoiceSalePage.all-categories') } ,
            ...this.invoiceCategories
        ]
    },

    matchedCategoryInvoices() {
        if(this.selectedInvoiceCategory) {
            return this.simplified_buy_invoices.filter(c => c.category_id === this.selectedInvoiceCategory)
        } else {
            return this.simplified_buy_invoices
        }
    },

    currencyNameCreate() {
        if (this.invoice_template.alternative_currency_id) {
            return this.$t('change-currency.currency') + ': ' + this.configs.currencies.find(c => c.id === this.invoice_template.alternative_currency_id)?.name
        }
        return this.$t('change-currency.currency')
    },

    currencyNameUpdate() {
        if (this.alternativeCurrencyId) {
            return this.$t('change-currency.currency') + ': ' + this.configs.currencies.find(c => c.id === this.alternativeCurrencyId)?.name
        }
        return this.$t('change-currency.currency')
    },

    disableDefaultCurrencyPrice() {
        return Boolean(this.alternativeCurrencyId === this.currentFinancialFile.default_currency_id)
    },

    disableDefaultCurrencyPriceCreate() {
        return Boolean(this.invoice_template.alternative_currency_id === this.currentFinancialFile.default_currency_id)
    },
    canAddFutureDate() {
        return this.getSettingByKey('CanAddFutureDate')?.setting_value;
    },
    showMaterialSpecificationsColumn() {
        return this.getSettingByKey('ShowMaterialSpecifications')?.setting_value;
    },
    useMaterialSerialNumber() {
        return this.getSettingByKey('UseMaterialSerialNumber')?.setting_value;
    },
    useDublicateMaterialSerialNumberAlert() {
        return this.getSettingByKey('DuplicateSerialNumAlert')?.setting_value;
    },
    accountFinalTypeRestrict() {
        return this.getSettingByKey('ValidateAccountType')?.setting_value
    },
    useExportPaymentBond() {
        return this.getSettingByKey('useExportPaymentReceiptBond')?.setting_value
    }
},
created() {
    this.inputsPaymentsOrExpenses.date = moment().format('YYYY-MM-DD')
    this.selectedInvoiceCategory = this.$route.query.invoiceCategory || null;
    !(this.deliveryStatus.length > 0) ? this.$store.dispatch('deliveryStatus/fetchAll') : null
    !this.users.length ? this.$store.dispatch('users/fetchAll') : null

    this.invoice_template.alternative_currency_id = this.currentFinancialFile.default_currency_id
    this.invoice_template.currency_price = 1
},
mounted(){
    
    window.observer.observe(document.querySelector("#tool-bar"))
    window.observer.observe(document.querySelector("#footer"));
    EventBus.$on('warehouse-changed', (warehouse_id, material_id = null)=>{ 
        if(!warehouse_id && material_id)
        {
            // تحديث قائمة مواد المستودع
            this.selected_warehouse_id = this.materials.find(c=>c.id == material_id)?.warehouse_id
            // تعيين المستودع التابع للمادة
            EventBus.$emit('initialize-last-row', { warehouse_id: this.selected_warehouse_id })
        }    
        else
            this.selected_warehouse_id =  warehouse_id
    });

    this.default_warehouse_id = this.configs.warehouse.id
    this.selected_warehouse_id = this.default_warehouse_id
    EventBus.$emit('initialize-last-row', { warehouse_id: this.selected_warehouse_id });

    const promises = [
        this.$store.dispatch("warehouses/fetchAll"),
        !this.materials.length ? this.fetchMaterials(false) : null,
        this.$store.dispatch("invoices/fetchAll", { invoiceType: this.invoiceType.buy }),
        useConfigInvoicesAccount && !Object.keys(this.defaultFinancialFileAccounts).length
            ? this.$store.dispatch('configs/fetchDefaultFinancialFileAccounts')
            : null,
    ];

    if (Object.keys(this.configs).length == 0) {
        promises.push(this.$store.dispatch('configs/fetchAll'))
    }
    if (!this.invoiceCategories.length && useInvoiceCategories) {
        promises.push(this.$store.dispatch('invoiceCategories/fetchAll'));
        promises.push(this.$store.dispatch('invoiceCategories/fetchDefaultCategories'));
    }
    
    if(this.$route.params.id) {
        promises.push(
            this.fetchInvoice()
            // this.$store.dispatch("invoices/fetch", {
            //     invoiceId: Number(this.$route.params.id),
            //     invoiceType: invoiceType.buy
            // }).then((data) => {
            //     if(this.$route.query.withCategory) {
            //         this.$router.push({name: 'invoices-buy', params: {id: this.$route.params.id}, query: {invoiceCategory: data.category_id} })
            //     }
            //     this.invoice_no = !this.$route.query.invoiceCategory ? data.no : data.sub_no;
            //     this.payment_type = data.payment_type;
            //     this.selectedInvoiceCategory = this.$route.query.invoiceCategory || null;
            //     // console.log(this.selectedInvoiceCategory);
            //     this.totalPayments = data.transactions.length ? data.transactions.filter(c => c.type === InvoicesTransactionType.payment).map(c =>
            //         this.invoice.alternative_currency_id
            //             ? c.alternative_amount?.amount
            //             : c.amount?.amount
            //      ).reduce((a, b) => a + b, 0) : null
            //     this.totalExpenses = data.transactions.length ? data.transactions.filter(c => c.type === InvoicesTransactionType.expensesBuy).map(c => 
            //         this.invoice.alternative_currency_id
            //             ? c.alternative_amount?.amount
            //             : c.amount?.amount
            //     ).reduce((a, b) => a + b, 0) : null
            //     this.changeWarehouse();
            //     this.alternativeCurrency = Boolean(this.invoice.alternative_currency_id)
            //     this.alternativeDiscountTotal = data.alternative_currency_id ? data.alternative_discount_total : data.discount_total
            //     if (this.invoice.alternative_currency_id === null) {
            //         this.alternativeCurrencyId = this.currentFinancialFile.default_currency_id;
            //         this.alternativeCurrencyPrice = 1
            //     } else {
            //         this.alternativeCurrencyId = this.invoice.alternative_currency_id
            //         this.recommendCurrencyPriceUpdate(this.alternativeCurrencyId)
            //     }
            //     // this.$refs.table.onEsc();
            // })
        )
        Promise.all(promises).then(() => {
            this.$nextTick(() => {
					if(!this.postingPermission){
						this.$refs.table.scrollToRow();
					}
            })
        });
    } else {
      //  this.$refs.table.openLoading();
        Promise.all(promises).then(() => {
            if(this.matchedCategoryInvoices.length > 0 && this.$route.name === 'invoices-buy') {
                this.$router.push({
                    name: 'invoices-buy',
                    params: { id: this.matchedCategoryInvoices[this.matchedCategoryInvoices.length - 1].id },
                    query: this.$route.query
                })
            }
        });
    }
},
methods:{
    moment,
    create(){
        this.loading = true
		store.dispatch("invoices/create",{
            invoiceType: invoiceType.buy,
            // invoice: this.invoice_template,
            invoice: {
                ...this.invoice_template,
                alternative_currency_id: 
                    this.invoice_template.alternative_currency_id !== this.configs.currencies.find(c => c.id === this.currentFinancialFile.default_currency_id).id 
                        ? this.invoice_template.alternative_currency_id
                        : null,

                currency_price: 
                    this.invoice_template.alternative_currency_id !== this.configs.currencies.find(c => c.id === this.currentFinancialFile.default_currency_id).id 
                        ? Number(this.invoice_template.currency_price)
                        : null,
            }
        })
		.then((data) => { 
            this.$store.dispatch("configs/fetchAll")

            /*fill the category autocomplete*/
            this.selectedInvoiceCategory = this.invoice_template.category_id;
            this.invoice_no =
                !this.selectedInvoiceCategory ? data.no : data.sub_no
            this.updateRouteId();
            this.alternativeCurrencyId = data.alternative_currency_id
            this.alternativeCurrencyPrice = data.currency_price
		})
		.finally(() => this.reSet());
    },

    updateRouteId(){
        const invoice =
            this.matchedCategoryInvoices?.find(c =>
                c[!this.selectedInvoiceCategory ? 'no' : 'sub_no'] === this.invoice_no
            );
        
		if (invoice && invoice.id !== Number(this.$route.params.id)){
			this.$router.push({
                name: 'invoices-buy',
                params: { id: invoice.id },
                query: {
                    ...this.$route.query,
                    invoiceCategory: this.selectedInvoiceCategory
                }
            })
		}
        this.$refs.table.resetInputs({
            warehouseId: this.selected_warehouse_id
        });
    },

    fetchInvoice(id = Number(this.$route.params.id)) {
            this.loading = true;
            return this.$store.dispatch("invoices/fetch", {
                invoiceId: id,
                invoiceType: invoiceType.buy
            }).then((data) => {
                this.invoice = JSON.parse(JSON.stringify(data));
                this.loading = false;
                if(this.$route.query.withCategory) {
                    this.$router.push({name: 'invoices-buy', params: {id: id}, query: {invoiceCategory: data.category_id} })
                }
                this.invoice_no = !this.$route.query.invoiceCategory ? data.no : data.sub_no;
                this.payment_type = data.payment_type;
                this.selectedInvoiceCategory = this.$route.query.invoiceCategory || null;
                // console.log(this.selectedInvoiceCategory);
                this.totalPayments = data.transactions.length ? data.transactions.filter(c => c.type === InvoicesTransactionType.payment).map(c =>
                    this.invoice.alternative_currency_id
                        ? c.alternative_amount?.amount
                        : c.amount?.amount
                 ).reduce((a, b) => a + b, 0) : null
                this.totalExpenses = data.transactions.length ? data.transactions.filter(c => c.type === InvoicesTransactionType.expensesBuy).map(c => 
                    this.invoice.alternative_currency_id
                        ? c.alternative_amount?.amount
                        : c.amount?.amount
                ).reduce((a, b) => a + b, 0) : null
                this.changeWarehouse();
                this.alternativeCurrency = Boolean(this.invoice.alternative_currency_id)
                this.alternativeDiscountTotal = data.alternative_currency_id ? data.alternative_discount_total : data.discount_total
                if (this.invoice.alternative_currency_id === null) {
                    this.alternativeCurrencyId = this.currentFinancialFile.default_currency_id;
                    this.alternativeCurrencyPrice = 1
                } else {
                    this.alternativeCurrencyId = this.invoice.alternative_currency_id
                    this.recommendCurrencyPriceUpdate(this.alternativeCurrencyId)
                }
                this.$nextTick(() => {
                    if(!this.postingPermission){
                        this.$refs.table.scrollToRow();
                        this.$refs.table.focus('materialId');
                    }
                })
                // this.$refs.table.onEsc();
            })
    },
    unPosting(postingTypeValue = this.userPostingTypeValue){ 
        this.updateInvoiceLoading = true;
        this.loading = true;
        store.dispatch("invoices/updateToNotPosted", { 
            invoiceId:this.invoice.id, 
            invoiceType: invoiceType.buy,
            posting_type: postingTypeValue })
            .then(()=>{
                // const promises = [ 
                    // store.dispatch("invoices/fetch", { invoiceId:this.invoice.id, invoiceType: invoiceType.buy }),
                // ]
                this.fetchInvoice(this.invoice.id)
                .then(() => {
                    this.$refs.table.scrollToRow();
                })
                .finally(() => {
                    this.loading = false;
                    this.updateInvoiceLoading = false
                    this.secondaryPostingButtonLoading = false;
                    this.primaryPostingButtonLoading = false;
                })
                if (postingTypeValue !== this.postingType.bond) {
                    this.fetchMaterials();
                    store.dispatch("materialsJournals/fetchAll", { fromDate: this.configs.financial_file.start_date, toDate: new Date().toISOString().substr(0, 10) })
                }
                if (postingTypeValue !== this.postingType.materialsJournal) {
                    store.dispatch("bonds/fetchAll", { bondType: bondType.accounting });
                    store.dispatch("configs/fetchAll")
                }
            }).catch(() => {
                this.loading = false;
                this.updateInvoiceLoading = false;
                this.secondaryPostingButtonLoading = false;
                this.primaryPostingButtonLoading = false;
            })
    },
    async posting(postingTypeValue = this.userPostingTypeValue){ 
        try {
            await this.entryHandler()
        }
        catch(error) {
            console.error(error);
        }
        this.loading = true;
        this.updateInvoiceLoading = true;
        store.dispatch("invoices/updateToPosted", { 
            invoiceId:this.invoice.id, 
            invoiceType: invoiceType.buy,
            posting_type: postingTypeValue
         })
            .then(()=>{
                // const promises = [
                    // store.dispatch("invoices/fetch", { invoiceId:this.invoice.id, invoiceType: invoiceType.buy }),
                // ]
                this.fetchInvoice(this.invoice.id).finally(() => {
                    this.loading = false;
                    this.updateInvoiceLoading = false;
                    this.confirmPostDialog = false
                    this.secondaryPostingButtonLoading = false;
                    this.primaryPostingButtonLoading = false;
                })
                if (postingTypeValue !== postingType.bond) {
                    this.fetchMaterials()
                    store.dispatch("materialsJournals/fetchAll", { fromDate: this.configs.financial_file.start_date, toDate: new Date().toISOString().substr(0, 10) })
                }
                if (postingTypeValue !== postingType.materialsJournal) {
                    store.dispatch("bonds/fetchAll", { bondType: bondType.accounting })
                    store.dispatch("configs/fetchAll")
                }
            }).catch(() => {
                this.loading = false;
                this.updateInvoiceLoading = false;
                this.secondaryPostingButtonLoading = false;
                this.primaryPostingButtonLoading = false;
            })
    },
    handlBlurBoundTable(invoiceEntry) {
        this.messagesSelectRowValidation = invoiceEntryDetectedValidation(invoiceEntry, this.linkedInvoiceRules, { price: this.isWarehousePermission || useZeroInvoiceEntiresPrice });
    },
    fetchInvoiceEntry(invoiceEntry){
        store.dispatch("invoices/fetchEntry",{ id: invoiceEntry.id, invoiceType: invoiceType.buy })
    },
    async entryHandler() {
        await this.$nextTick(() => {});
        if(this.useMaterialSerialNumber) {
            this.serialNumber.value
                            ? Array.isArray(this.tableInputs['serial-number']) 
                                ? this.tableInputs['serial-number'].push(this.serialNumber) 
                                : this.tableInputs['serial-number'] = [this.serialNumber]
                            : null
                    this.serialNumber = {}
        }
        if (this.$refs.table.validate()) {
            this.entryLoading = true;
            const actionName = !this.entryId ? 'createEntry' : 'updateEntry' ;
            const entryData = {
                id: this.entryId,
                invoice_id: this.invoice.id,
                material_id: this.tableInputs.materialId,
                quantity: {
                    quantity: this.tableInputs.quantity,
                    unit_size_id: null
                },
                count: this.tableInputs.count,
                notes: this.tableInputs.notes,
                type: invoiceType.buy,
                delivery_status_id: this.tableInputs.delivery_status_id,
                serial_number: Array.isArray(this.tableInputs['serial-number']) ? this.tableInputs['serial-number'].map(v => v.value) : []
            };
            if(this.invoice.alternative_currency_id) {
                entryData.alternative_price = 
                    this.tableInputs.price
                        ? {
                            amount:  this.tableInputs.price,
                            currency_id: this.alternativeCurrencyId
                        }
                        : {
                            amount:  0,
                            currency_id: this.alternativeCurrencyId
                        },

                entryData.alternative_calculated_total_amount = 
                    this.tableInputs.calculatedTotalAmount
                        ? {
                            amount:  this.tableInputs.calculatedTotalAmount,
                            currency_id: this.alternativeCurrencyId
                        }
                        : {
                            amount:  0,
                            currency_id: this.alternativeCurrencyId
                        }
            } else if (!this.invoice.alternative_currency_id) {
                entryData.price =
                    this.tableInputs.price
                        ? {
                            amount:  this.tableInputs.price,
                            currency_id: this.currentFinancialFile.default_currency_id
                        }
                        : {
                            amount:  0,
                            currency_id: this.currentFinancialFile.default_currency_id
                        },

                entryData.calculated_total_amount = 
                    this.tableInputs.calculatedTotalAmount
                        ? {
                            amount:  this.tableInputs.calculatedTotalAmount,
                            currency_id: this.currentFinancialFile.default_currency_id
                        }
                        : {
                            amount:  0,
                            currency_id: this.currentFinancialFile.default_currency_id
                        }
            }


            if (!entryData.id) { delete entryData.id ;}
            return store.dispatch(`invoices/${actionName}`, {
                invoiceId: this.invoice.id,
                invoiceType: invoiceType.buy,
                invoiceEntry: entryData
            })
            .then(() => {
                if (this.entryId) {
                    const entryIndex = this.entries.findIndex(c => c.id === this.entryId);
                    if (entryIndex !== -1) {
                        this.entries[entryIndex].warehouse_id = this.tableInputs.warehouseId;
                        this.entries[entryIndex].material_id = this.tableInputs.materialId;
                        this.entries[entryIndex].quantity = this.tableInputs.quantity;
                        this.entries[entryIndex].count = this.tableInputs.count;
                        this.entries[entryIndex].notes = this.tableInputs.notes;
                        this.entries[entryIndex].delivery_status_id = this.tableInputs.delivery_status_id
                    }
                }
                this.fetchInvoice(this.invoice.id)
                // store.dispatch('invoices/fetch', {
                //     invoiceId: this.invoice.id,
                //     invoiceType: invoiceType.buy
                // }).then((data) => {
                //     this.$refs.table.scrollToRow();
                //     if(data.payment_type === paymentType.cash) {
                //         this.totalPayments =
                //             data.transactions.length
                //                 ? data.transactions
                //                     .filter(c => c.type === InvoicesTransactionType.payment)
                //                     .map(c => 
                //                         this.invoice.alternative_currency_id 
                //                             ? c.alternative_amount?.amount 
                //                             : c.amount?.amount
                //                         )
                //                     .reduce((a, b) => a + b, 0)
                //                 : null
                //     }
                // });
                if (this.entryId) {
                    this.entryId = null;
                    const nextRowIndex = this.$refs.table.editNextRow();
                    if (nextRowIndex !== -1) {
                        this.entryId = this.entries[nextRowIndex].id;
                        this.$refs.table.scrollToRow();
                    } else {
                        this.$refs.table.resetInputs({
                            warehouseId: this.selected_warehouse_id
                        });
                    }
                } else {
                    this.$refs.table.scrollToRow();
                    this.$refs.table.resetInputs({
                        warehouseId: this.selected_warehouse_id
                    });
                }

                // this.$nextTick(() => {
                //     this.$nextTick(() => {
                //         this.$nextTick(() => {
                //             if (this.entryId) {
                //                 setTimeout(() => {
                //                     // this.$refs.table.resetInputsFocus();
                //                     this.$refs.table.focus('materialId');
                //                 }, 100);
                //             }
                //             else {
                //                 // this.$refs.table.resetInputsFocus();
                //                 this.$refs.table.focus('materialId');
                //             }
                //         })
                //     })
                // })
            })
            .finally(() => {
                this.entryLoading = false;
                // this.$refs.table.resetInputsFocus();
                // this.$refs.table.focus('materialId');
            })
        }
    },
    updateEntry(invoiceEntry){        
        let entry = refactorRecord(this.entries[invoiceEntry.rowIndex], this.configs.financial_file.default_currency_id)
        entry.invoice_id = this.invoice.id
        delete entry.discount_percentage
        delete entry.discount_amount
        
        if(this.$refs.table.$refs.table.$refs.table.valids[`valid_${invoiceEntry.rowIndex}`])
            store.dispatch("invoices/updateEntry", {
                invoiceId: entry.invoice_id,
                invoiceType: invoiceType.buy,
                invoiceEntry: { 
                    ...entry,
                    price: entry.price ? entry.price : {
                        amount:  0,
                        currency_id: this.currentFinancialFile.default_currency_id
                    } ,
                    calculated_total_amount: entry.calculated_total_amount ? entry.calculated_total_amount : {
                        amount:  0,
                        currency_id: this.currentFinancialFile.default_currency_id
                    },

                    alternative_price: this.alternativeCurrency ? entry.price : null,

                    alternative_calculated_total_amount: this.alternativeCurrency ? entry.calculated_total_amount : null
                }
            })
            .then(() => { 
                // store.dispatch("invoices/fetch", { invoiceId: entry.invoice_id, invoiceType: invoiceType.buy })
                this.fetchInvoice(entry.invoice_id)
                invoiceEntry.deleteRowIndex()
            })
            .finally(()=>{
                invoiceEntry.connectionEnded(1, "BeeAutocomplete")
            })
        else
            EventBus.$emit('error', 'تأكد من صحة البيانات المدخلة')
    },
    addInvoiceEntry(invoiceEntry){
        let entry = refactorRecord(invoiceEntry.value, this.configs.financial_file.default_currency_id)
        entry.invoice_id = this.invoice.id
        entry.type = invoiceType.buy
        if (!entry.id) { delete entry.id }
        delete entry.discount_percentage
        delete entry.discount_amount
        // console.log({ 
        //     ...entry,
        //     price: entry.price ? entry.price : {
        //         amount:  0,
        //         currency_id: this.currentFinancialFile.default_currency_id
        //     } ,
        //     calculated_total_amount: entry.calculated_total_amount ? entry.calculated_total_amount : {
        //         amount:  0,
        //         currency_id: this.currentFinancialFile.default_currency_id
        //     }
        // });
        
        store.dispatch("invoices/createEntry", {
			invoiceId: this.invoice.id,
			invoiceType: invoiceType.buy,
            invoiceEntry: { 
                ...entry,
                price: entry.price ? entry.price : {
                    amount:  0,
                    currency_id: this.currentFinancialFile.default_currency_id
                } ,
                calculated_total_amount: entry.calculated_total_amount ? entry.calculated_total_amount : {
                    amount:  0,
                    currency_id: this.currentFinancialFile.default_currency_id
                }
            }	
        })
        .then(() => {
            // store.dispatch("invoices/fetch", { invoiceId: this.invoice.id, invoiceType: invoiceType.buy })
            this.fetchInvoice(this.invoice.id);
            invoiceEntry.deleteRowData({ warehouse_id: this.selected_warehouse_id })
        }).finally(()=>{
            invoiceEntry.connectionEnded(1, "BeeAutocomplete")
        })
    },
    deleteInvoiceEntry(invoiceEntry){
		this.entry = {...invoiceEntry}
		this.dialogDeleteEntry = true
    },
	confirmDeleteInvoiceEntry(){
		store.dispatch("invoices/deleteEntry", { invoiceId: this.invoice.id, invoiceType: invoiceType.buy, invoiceEntryId: this.entry.id }).then(()=>{
            this.fetchInvoice(this.invoice.id);
			// store.dispatch("invoices/fetch", { invoiceId: this.invoice.id, invoiceType: invoiceType.buy }).then(data => {
            //     if(data.payment_type === paymentType.cash) {
            //         this.totalPayments =
            //             data.transactions.length
            //                 ? data.transactions
            //                     .filter(c => c.type === InvoicesTransactionType.payment)
            //                     .map(c => 
            //                         this.invoice.alternative_currency_id 
            //                             ? c.alternative_amount?.amount 
            //                             : c.amount?.amount
            //                         )
            //                     .reduce((a, b) => a + b, 0)
            //                 : null

            //     }
            // })
		}).finally(()=>{
			this.entry = null
		})
	},
    update(){
        let invoice = {
            external_account_id : this.invoice.external_account_id,
            date: this.invoice.date,
            doc_no: this.invoice.doc_no,
        }
        let required = false
        Object.keys(invoice).forEach((key) => {
            if (key === 'doc_no' && canCreateInvoiceWithoutDocNo) {
                return
            } else if (!invoice[key]) {
                required = true;
            }
        })

        invoice.total_net = { amount: this.alternativeCurrency ? 0 :this.total_net, currency_id: this.configs.financial_file.default_currency_id }
        invoice.alternative_total_net = 
            this.alternativeCurrency
                ? {
                    amount: this.total_net,
                    currency_id: this.invoice.alternative_currency_id
                }
                : null
        invoice.notes =  this.invoice.notes
        invoice.account_trade_config_id = this.invoice.account_trade_config_id
        invoice.category = this.invoice.category || 0
        invoice.payment_type = this.change_payment_type || this.invoice?.payment_type
        invoice.discount_total = !this.invoice.alternative_currency_id 
            ? {
                amount: this.alternativeDiscountTotal?.amount ,
                currency_id: this.currentFinancialFile.default_currency_id
            }
            : null

        invoice.alternative_discount_total = this.invoice.alternative_currency_id 
            ? {
                amount: this.alternativeDiscountTotal?.amount ,
                currency_id: this.invoice.alternative_currency_id
            } 
            : null

        invoice.alternative_currency_id = 
            !(this.alternativeCurrencyId === this.configs.currencies.find(c => c.id === this.currentFinancialFile.default_currency_id).id)
                ? this.alternativeCurrencyId
                : null

        invoice.currency_price =
            !(this.alternativeCurrencyId === this.configs.currencies.find(c => c.id === this.currentFinancialFile.default_currency_id).id)
                ? Number(this.alternativeCurrencyPrice)
                : null

        if (((this.alternativeCurrencyId !== null && this.alternativeCurrencyId !== this.currentFinancialFile.default_currency_id) && this.invoice.alternative_currency_id !== null) && this.alternativeCurrencyId != this.invoice.alternative_currency_id) {
            this.changeCurrencyAlertDialog = true
            this.alternativeCurrencyId = this.invoice.alternative_currency_id
        } else {
            if(!required && (this.alternativeDiscountTotal?.amount || 0) <= this.total &&(this.invoice.date <= moment().format('YYYY-MM-DD') || this.canAddFutureDate))
                store.dispatch("invoices/update",{ invoiceId: this.invoice.id, invoiceType: invoiceType.buy, invoice })
                .then(() => { 
                    this.fetchInvoice();
                    // this.$store.dispatch("invoices/fetch", {
                    //     invoiceId: Number(this.$route.params.id),
                    //     invoiceType: invoiceType.buy 
                    // }).then((data) => {
                    //     this.invoice_no = !this.$route.query.invoiceCategory ? data.no : data.sub_no;
                    //     this.payment_type = data.payment_type;
                    //     this.alternativeCurrencyId = data.alternative_currency_id
                    //     this.alternativeCurrencyPrice = data.currency_price
                    //     this.alternativeDiscountTotal = data.alternative_currency_id ? data.alternative_discount_total : data.discount_total
                    //     this.changeWarehouse();
                    //     // this.$refs.table.onEsc();

                    //     this.alternativeCurrency = Boolean(this.invoice.alternative_currency_id)
                    //     if (this.alternativeCurrencyId === null) {
                    //         this.alternativeCurrencyId = this.currentFinancialFile.default_currency_id
                    //         this.alternativeCurrencyPrice = 1
                    //     }
                    //     this.totalPayments =
                    //     data.transactions.length
                    //         ? data.transactions
                    //             .filter(c => c.type === InvoicesTransactionType.payment)
                    //             .map(c => 
                    //                 this.invoice.alternative_currency_id 
                    //                     ? c.alternative_amount?.amount 
                    //                     : c.amount?.amount
                    //                 )
                    //             .reduce((a, b) => a + b, 0)
                    //         : null
                    //     this.totalExpenses =
                    //         data.transactions.length
                    //             ? data.transactions
                    //                 .filter(c => c.type === InvoicesTransactionType.expensesBuy)
                    //                 .map(c => 
                    //                     this.invoice.alternative_currency_id 
                    //                         ? c.alternative_amount?.amount 
                    //                         : c.amount?.amount
                    //                     )
                    //                 .reduce((a, b) => a + b, 0)
                    //             : null
                    // })
                    this.currentCurrencyDialog = false
                    EventBus.$emit("notification", this.$t('AllInvoicesPage.invoice-updated-successfully'));
                    this.alternativeCurrency = Boolean(this.invoice.alternative_currency_id)
                    if (this.alternativeCurrencyId === null) {
                        this.alternativeCurrencyId = this.currentFinancialFile.default_currency_id
                        this.alternativeCurrencyPrice = 1
                    }
                })
            else
                EventBus.$emit('error', 'تأكد من صحة البيانات المدخلة')
            }

        
    },
    changeWarehouse(){
        // EventBus.$emit('initialize-last-row', { warehouse_id: this.default_warehouse_id })
        this.selected_warehouse_id = this.default_warehouse_id
        this.tableInputs.warehouseId = this.default_warehouse_id
    },
    reSet(){
        this.loading = false
        this.invoice_template.external_account_id = null
        this.invoice_template.doc_no = null
        this.invoice_template.notes = null
        this.invoice_template.date = moment().format('YYYY-MM-DD')
        this.addInvoiceDialog = false
        this.$refs.form.resetValidation()
        this.invoice_template.alternative_currency_id = this.currentFinancialFile.default_currency_id
        this.invoice_template.currency_price = 1
    },
    deleteInvoice(){
        store.dispatch("invoices/delete", { invoiceId:this.invoice.id, invoiceType: invoiceType.buy })
            .then(()=>{ 
                Promise.all([
                    store.dispatch("configs/fetchAll"), 
                    store.dispatch("invoices/fetchAll", { invoiceType: this.invoiceType.buy }),
                    store.dispatch("bonds/fetchAll", { bondType: bondType.accounting })
                ]).then(() => {
                    if (this.matchedCategoryInvoices.length > 0){
                        this.invoice_no =
                            this.matchedCategoryInvoices[this.matchedCategoryInvoices.length -1][
                                !this.$route.query.invoiceCategory ? 'no' : 'sub_no'
                            ]
                        this.updateRouteId();
                    }
                    else
                        this.$router.push({ name: 'invoices-buy' })
                            .then(()=> this.$router.go(0) /** Force refresh to empty the store*/ )
                    })
            })
    },

    addRowForEntriesDialog(type) {
        if(this.$refs.tablePayment.validate()) {
            this.submitLoading = true
            const entryData =  {
                invoice_id: this.invoice.id,
                date: this.inputsPaymentsOrExpenses.date,
                type: type,
                notes: this.inputsPaymentsOrExpenses.notes,
                account_id: this.inputsPaymentsOrExpenses.account_id ? this.inputsPaymentsOrExpenses.account_id : null
            }
            this.$store.dispatch('transactions/create', {   
                entryData: {
                    ...entryData,
                    alternative_amount: 
                        this.alternativeCurrency 
                            ? {
                                amount: this.inputsPaymentsOrExpenses.amount,
                                currency_id: this.invoice.alternative_currency_id
                            }
                            : null,
                    amount: 
                        !this.alternativeCurrency 
                        ? {
                            amount: this.inputsPaymentsOrExpenses.amount,
                            currency_id: this.currentFinancialFile.default_currency_id
                        }
                        : null
                },
                invoiceType: invoiceType.buy, 
                invoiceId: this.invoice.id 
            }).then(() => {
                this.getAllPaymentsOrExpenses(type)
            })
            this.$refs.tablePayment.resetInputs()
            this.inputsPaymentsOrExpenses.date = this.invoice.date;
        }
    },

    editRowForEntriesDialog(type) {
        this.submitLoading = true
        const entryData =  {
            invoice_id: this.invoice.id,
            date: this.inputsPaymentsOrExpenses.date,
            type: type,
            notes: this.inputsPaymentsOrExpenses.notes,
            account_id: this.inputsPaymentsOrExpenses.account_id ? this.inputsPaymentsOrExpenses.account_id : null
        }
        this.$store.dispatch('transactions/update', {   
            entryData: {
                ...entryData,
                alternative_amount: 
                    this.alternativeCurrency 
                        ? {
                            amount: this.inputsPaymentsOrExpenses.amount,
                            currency_id: this.invoice.alternative_currency_id
                        }
                        : null,
                amount: 
                    !this.alternativeCurrency 
                    ? {
                        amount: this.inputsPaymentsOrExpenses.amount,
                        currency_id: this.currentFinancialFile.default_currency_id
                    }
                    : null
            },
            transactionId: this.transactionId, 
            invoiceId: this.invoice.id,
            invoiceType: invoiceType.buy
        }).then(() => {
            this.getAllPaymentsOrExpenses(type)
        }).finally(() => {
            this.$refs.tablePayment.resetEdit();
            this.isEdit = false;
        })
        this.$nextTick(() => {
            this.$refs.tablePayment.resetInputs({
                date: moment().format('YYYY-MM-DD')
            })
            this.$refs.tablePayment.resetInputsFocus()
        })
    },

    deleteRowForPayments() {
        this.submitLoading = true
        this.$store.dispatch('transactions/delete', { transactionId: this.transactionId }).then(() => {
            this.getAllPaymentsOrExpenses(this.isExpenses ? InvoicesTransactionType.expensesBuy : InvoicesTransactionType.payment)
        }).finally(() => {
            this.submitLoading = false
            this.transactionId = null
        })
    },

    getAllPaymentsOrExpenses(type) {
        this.submitLoading = true
        this.$store.dispatch('transactions/fetchTransaction', { 
            invoiceType: invoiceType.buy, 
            invoiceId: this.invoice.id,
            transactionType: type
        }).then((data) => {
            this.entriesDialog = data.data
            if(!this.isExpenses) {
                this.totalPayments = this.entriesDialog.length ? this.entriesDialog.map(c =>
                    this.invoice.alternative_currency_id
                        ? c.alternative_amount?.amount
                        : c.amount?.amount
                ).reduce((a, b) => a + b, 0) : null
            } else {
                this.totalExpenses = this.entriesDialog.length ? this.entriesDialog.map(c =>
                    this.invoice.alternative_currency_id
                        ? c.alternative_amount?.amount
                        : c.amount?.amount
                ).reduce((a, b) => a + b, 0) : null
            }
            this.submitLoading = false
            this.inputsPaymentsOrExpenses.date = this.invoice.date;
        }).finally(() => {
            this.submitLoading = false
        })
    },

    confirmTotalPaymentsForTotalNet() {
        const type = !this.isExpenses ? InvoicesTransactionType.payment : InvoicesTransactionType.expensesBuy
        if (this.isExpenses) {
            if(!this.isEdit) {
                this.addRowForEntriesDialog(type)
            } else {
                this.editRowForEntriesDialog(type)
            }
        } else {
            if (
                (((this.totalPayments + this.inputsPaymentsOrExpenses.amount) > this.total_net) && !this.isEdit)
            ) {
                this.alertMessageDialog = true
            } else if(
                (   
                    ((this.totalPayments - (typeof this.editRowIndex === 'number' ? this.entriesDialog[this.editRowIndex].amount.amount : 0) + this.inputsPaymentsOrExpenses.amount) > this.total_net) && 
                    this.isEdit
                )
            ) {
                this.alertMessageDialog = true
            } else {
                if(!this.isEdit) {
                    this.addRowForEntriesDialog(type)
                } else {
                    this.editRowForEntriesDialog(type)
                }
            }
        }
        
    },

    suggestCategoryData() {
        if (!useInvoiceCategories) return;
        let matchedCategory = this.getInvoiceCategoryById(this.invoice_template.category_id);
        if(matchedCategory) {
            this.invoice_template.account_trade_config_id = matchedCategory?.purchases_account_id;
            this.invoice_template.external_account_id = matchedCategory?.customer_account_id;
        }
    },
    fetchMaterials(isUpdate = true) {
        this.materialsLoading = true;
        return this.$store.dispatch('materials/fetchAll').finally(() => {
            this.materialsLoading = false;
            if(isUpdate) {
                EventBus.$emit('notification', this.$t('update-materials-notifications'))
            }
        })
    },
    getReport(type) {
        this.$store.dispatch('reports/invoice', {
            type,
            financialFileId: this.currentFinancialFile.id,
            userId: ls.getLocalUser().id,
            invoiceType: invoiceType.buy,
            invoiceId: this.invoice.id,
            withDeliveryStatus: this.useMaterialStatusDeliver
        })
    },

    recommendMaterialData() {
        this.tableInputs['serial-number'] = [];
        if(this.tableInputs.materialId) {
            const material = this.materials.find(c => c.id === this.tableInputs.materialId)
            this.tableInputs.price = material?.purchase_price?.amount / (this.invoice.currency_price || 1);
            this.tableInputs['material-specifications'] = material?.specifications;
            this.tableInputs.quantity = null;
            this.tableInputs['calculatedTotalAmount'] = 0;
        }
    },

    recommendCurrencyPriceCreate(value) {
        if (value === this.currentFinancialFile.default_currency_id) {
            this.invoice_template.currency_price = 1
        } else {
            this.invoice_template.currency_price = this.configs.currencies.find(e => e.id === value).latest_exchange_record
        }
    },

    recommendCurrencyDefaultPriceUpdate(value) {
        if (value === this.currentFinancialFile.default_currency_id) {
            this.alternativeCurrencyPrice = 1
        } else {
            this.alternativeCurrencyPrice = this.configs.currencies.find(e => e.id === value).latest_exchange_record
        }
    },
    recommendCurrencyPriceUpdate(value) {
        if(this.invoice.alternative_currency_id === value) {
            this.alternativeCurrencyPrice = this.invoice.currency_price
        } else {
            this.alternativeCurrencyPrice = this.configs.currencies.find(e => e.id === value).latest_exchange_record
        }
    },

    resetCurrencyDialog() {
        if (this.invoice.alternative_currency_id === null) {
            this.alternativeCurrencyId = this.currentFinancialFile.default_currency_id
            this.alternativeCurrencyPrice = 1
        } else {
            this.alternativeCurrencyId = this.invoice.alternative_currency_id
            this.alternativeCurrencyPrice = this.invoice.currency_price
        }
    },
    tableDisabledInputs(input) {
        if(this.postingPattern === postingPriorityType.warehouseWorkersFirst){
            if(this.isAccountantPermission && this.invoice.posting_type === postingType.unknown)
                return input !== 'price' && input !== 'calculatedTotalAmount';
            if(this.invoice.posting_type === postingType.materialsJournal)
                return input !== 'price' && input !== 'calculatedTotalAmount';
        }
        if(this.postingPattern === postingPriorityType.accountantFirst) {
            if(this.invoice.posting_type === postingType.bond) 
                return input !== 'notes'
        }
    return false;
    },
    checkMaterialSerialNumber(materialId, serialNumber) {
        console.log(materialId, serialNumber)
        if(materialId && serialNumber && this.useDublicateMaterialSerialNumberAlert) {
            if(this.tableInputs['serial-number'].find(v => v.value  === serialNumber)) {
                this.serialNumberAlertDialog = true;
                this.serialNumberAlertText = serialNumber;
                return ;
            } 
            return this.$store.dispatch('materials/checkSerialNumber', {materialId, serialNumber}).then(data => {
                if(data) {
                    this.serialNumberAlertDialog = true;
                    this.serialNumberAlertText = serialNumber;
                }
            })
        }
    },
    resetSerialNumberValue() {
        this.checkMaterialSerialNumber(this.tableInputs.materialId, this.serialNumber.value)
        this.serialNumber.value
            ? Array.isArray(this.tableInputs['serial-number']) 
                ? this.tableInputs['serial-number'].push(this.serialNumber) 
                : this.tableInputs['serial-number'] = [this.serialNumber]
            : null
        if(this.$refs.serialNumberTable) {
            this.$refs.serialNumberTable.resetInputs();
            this.$refs.serialNumberTable.resetInputsFocus();
        } else {
            this.serialNumber = {}
        }

    },
    exportPaymentBond(item) {
        const ids = [item.id];
        this.$store.dispatch('reports/paymentReceiptInvoiceBond', {
            financialFileId: this.currentFinancialFile.id,
            userId: ls.getLocalUser().id,
            type: 'pdf',
            subBondType: paymentReceiptBondType.payment,
            transactionIds: ids
        })
    },
},
/*
async beforeRouteEnter(to, from, next) {
	let promises = [store.dispatch("warehouses/fetchAll"), store.dispatch("materials/fetchAll"), store.dispatch("invoices/fetchAll", 'Buy')]
	let object = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(object).length == 0)
		promises.push(store.dispatch("configs/fetchAll"))

	if(promises.length)
		await Promise.all(promises)

    if(to.params.id)
	{
		if(to.name != 'invoice-buy')
			next({name: 'invoice-buy', params:{id: to.params.id}})
	}	
	else
	{
		let buy_invoices = JSON.parse(JSON.stringify(store.state.invoices.simplified_buy_invoices))
		if(buy_invoices.length > 0)
			next({ name: 'invoice-buy', params:{id: buy_invoices[buy_invoices.length -1].id }})
	}

	next(
		vm => {
			if(to.name == "invoice-buy")
			{
				if(to.params.id)
				{
					vm.$refs.table.openLoading();
					store.dispatch("invoices/fetch", { invoiceId: Number(to.params.id), invoiceType:"Buy" })
						.then(response=> { 
							vm.invoice_no = response.no
							vm.changeWarehouse()
							vm.$refs.table.onEsc(),
							vm.$refs.table.closeLoading();})
				}
			} 
		})
}*/
}
</script>
<style>
.my-border {
	border: 1px solid !important;
	border-color: #f1f1f1 !important;	
}
.v-bottom-navigation {
	overflow-y: unset;
	box-shadow: 0px 10px 5px #eee, 0px -2px 5px gainsboro !important;
	background: linear-gradient(180deg, rgba(241,241,241,1) 0%, rgba(230,240,245,1) 100%);
}
.fill-height
{
height: 100% !important;
}
</style>
